import { createRouter, createWebHistory, createWebHashHistory, type RouteRecordRaw, type RouteLocationNormalized, RouterView, useRoute } from 'vue-router'
import { h, defineComponent } from 'vue'
import { isMobileDevice } from '@/utils/device'
import { useAuthStore } from '@/stores/auth'

// 레이아웃 컴포넌트
const PcLayout = () => import('@/layouts/PcLayout.vue')
const MobileLayout = () => import('@/layouts/MobileLayout.vue')

// 로그인 페이지
const LoginPage = () => import('@/views/mobile/auth/LoginPage.vue')

// PC 페이지
const PcHomePage = () => import('@/views/pc/HomePage.vue')
const PcServiceGuidePage = () => import('@/views/pc/PcServiceGuidePage.vue')
const PcClubIntroPage = () => import('@/views/pc/ClubIntroPage.vue')
const PcNewsListPage = () => import('@/views/pc/NewsListPage.vue')
const PcNewsDetailPage = () => import('@/views/pc/NewsDetailPage.vue')
const PcClubCreatePage = () => import('@/views/pc/ClubCreatePage.vue')
const PcNotificationPage = () => import('@/views/pc/NotificationPage.vue')
const PcNotificationSettingPage = () => import('@/views/pc/NotificationSettingPage.vue')
const PcClubBoardPage = () => import('@/views/pc/ClubBoardPage.vue')
const PcClubBoardWritePage = () => import('@/views/pc/ClubBoardWritePage.vue')
const PcFeeManagePage = () => import('@/views/pc/FeeManagePage.vue')
const PcMemberFeePage = () => import('@/views/pc/PcMemberFeePage.vue')
const PcManagerTransferAcceptPage = () => import('@/views/pc/PcManagerTransferAcceptPage.vue')
// 4차발주 F-9(통합본 p113): 재무리포트 PC — 열람 전회원, 작성만 운영진
// 4차발주 B-2(p87)·D-5(p58 노트): 알림스튜디오 + 단계별 공지 PC
const PcEventNotifyStudioPage = () => import('@/views/pc/EventNotifyStudioPage.vue')
const PcFinanceReportPage = () => import('@/views/pc/FinanceReportPage.vue')
const PcFinanceReportWritePage = () => import('@/views/pc/FinanceReportWritePage.vue')
const PcCarpoolBoardPage = () => import('@/views/pc/CarpoolBoardPage.vue')
const PcCarpoolWritePage = () => import('@/views/pc/CarpoolWritePage.vue')
const PcCarpoolDetailPage = () => import('@/views/pc/CarpoolDetailPage.vue')
const PcPlatformNoticePage = () => import('@/views/pc/PlatformNoticePage.vue')
const PcPlatformNoticeDetailPage = () => import('@/views/pc/PlatformNoticeDetailPage.vue')
const PcGolfCourseRankingPage = () => import('@/views/pc/GolfCourseRankingPage.vue')
const PcGolfCourseSearchPage = () => import('@/views/pc/GolfCourseSearchPage.vue')
const PcMemberListPage = () => import('@/views/pc/MemberListPage.vue')
const PcEventListPage = () => import('@/views/pc/EventListPage.vue')
const PcEventCreatePage = () => import('@/views/pc/EventCreatePage.vue')
const PcSettlementBoardPage = () => import('@/views/pc/SettlementBoardPage.vue')
const PcSettlementCreatePage = () => import('@/views/pc/SettlementCreatePage.vue')
const PcSettlementEditPage = () => import('@/views/pc/SettlementEditPage.vue')
const PcVoteListPage = () => import('@/views/pc/PcVoteListPage.vue')
const PcVoteCreatePage = () => import('@/views/pc/PcVoteCreatePage.vue')
const PcVoteDetailPage = () => import('@/views/pc/PcVoteDetailPage.vue')
const PcLoginPage = () => import('@/views/pc/LoginPage.vue')
const PcSignupPage = () => import('@/views/pc/SignupPage.vue')
const PcMyPage = () => import('@/views/pc/MyPage.vue')
const PcFaqPage = () => import('@/views/pc/FaqPage.vue')
const PcInquiryWritePage = () => import('@/views/pc/InquiryWritePage.vue')
const PcInquiryListPage = () => import('@/views/pc/InquiryListPage.vue')
const PcInquiryDetailPage = () => import('@/views/pc/InquiryDetailPage.vue')
const PcGroupBuyPage = () => import('@/views/pc/GroupBuyPage.vue')
const PcUrgentJoinListPage = () => import('@/views/pc/PcUrgentJoinListPage.vue')
const PcUrgentJoinCreatePage = () => import('@/views/pc/PcUrgentJoinCreatePage.vue')
const PcUrgentJoinDetailPage = () => import('@/views/pc/PcUrgentJoinDetailPage.vue')
const PcComingSoonPage = () => import('@/views/pc/ComingSoonPage.vue')
const PcClubChatPage = () => import('@/views/pc/PcClubChatPage.vue')
const PcClubJoinPage = () => import('@/views/pc/ClubJoinPage.vue')
const PcClubJoinCompletePage = () => import('@/views/pc/PcClubJoinCompletePage.vue')
const PcClubMyAnswersPage = () => import('@/views/pc/PcClubMyAnswersPage.vue')
const PcMyClubListPage = () => import('@/views/pc/PcMyClubListPage.vue')
const PcScoreReportListPage = () => import('@/views/pc/PcScoreReportListPage.vue')
const PcScoreReportDetailPage = () => import('@/views/pc/PcScoreReportDetailPage.vue')
const PcScorePersonalPage = () => import('@/views/pc/PcScorePersonalPage.vue')
const PcScoreRankingPage = () => import('@/views/pc/PcScoreRankingPage.vue')
const PcAwardManagePage = () => import('@/views/pc/PcAwardManagePage.vue')
const PcEventWinnersPage = () => import('@/views/pc/PcEventWinnersPage.vue')
const PcEventWinnersDetailPage = () => import('@/views/pc/PcEventWinnersDetailPage.vue')
const PcEventScoreAdminPage = () => import('@/views/pc/PcEventScoreAdminPage.vue')
const PcEventPostCloseHubPage = () => import('@/views/pc/PcEventPostCloseHubPage.vue')
const PcRoundingParticipationPage = () => import('@/views/pc/PcRoundingParticipationPage.vue')
const PcHallOfFamePage = () => import('@/views/pc/PcHallOfFamePage.vue')
const PcGuinnessPage = () => import('@/views/pc/PcGuinnessPage.vue')
// 2026-05-10 P2-③ ADMIN 운영 화면 신설 (memory: feature_pc_guinness_hof_admin.md)
const PcGuinnessSettingPage = () => import('@/views/pc/PcGuinnessSettingPage.vue')
const PcHallOfFameManagePage = () => import('@/views/pc/PcHallOfFameManagePage.vue')
const PcHallOfFameSettingPage = () => import('@/views/pc/PcHallOfFameSettingPage.vue')
const PcTournamentListPage = () => import('@/views/pc/PcTournamentListPage.vue')
const PcTournamentDetailPage = () => import('@/views/pc/PcTournamentDetailPage.vue')
const PcEventDetailPage = () => import('@/views/pc/EventDetailPage.vue')
const PcClubBoardDetailPage = () => import('@/views/pc/ClubBoardDetailPage.vue')
const PcClubEditPage = () => import('@/views/pc/ClubEditPage.vue')
const PcClubSubscriptionPage = () => import('@/views/pc/PcClubSubscriptionPage.vue')
const PcClubCashWalletPage = () => import('@/views/pc/PcClubCashWalletPage.vue')
const PcMemberDetailPage = () => import('@/views/pc/MemberDetailPage.vue')
const PcFindIdPage = () => import('@/views/pc/FindIdPage.vue')
const PcProfileEditPage = () => import('@/views/pc/ProfileEditPage.vue')
const PcSponsorListPage = () => import('@/views/pc/SponsorListPage.vue')
const PcSponsorViewPage = () => import('@/views/pc/SponsorViewPage.vue')
const PcSponsorWritePage = () => import('@/views/pc/SponsorWritePage.vue')
const PcPointsPage = () => import('@/views/pc/PointsPage.vue')
const PcPointInfoPage = () => import('@/views/pc/PointInfoPage.vue')
const PcShopReviewWritePage = () => import('@/views/pc/ShopReviewWritePage.vue')
const PcOrderHistoryPage = () => import('@/views/pc/OrderHistoryPage.vue')
const PcClubJoinRequestsPage = () => import('@/views/pc/ClubJoinRequestsPage.vue')
const PcTermsPage = () => import('@/views/pc/TermsPage.vue')
const PcGolfCourseDetailPage = () => import('@/views/pc/GolfCourseDetailPage.vue')
const PcSettlementDetailPage = () => import('@/views/pc/SettlementDetailPage.vue')
const PcClubSearchPage = () => import('@/views/pc/ClubSearchPage.vue')
// @figma-override:F-SCH1 — 통합검색 (10/2본 질문 31 · 2026-10-04)
const PcSearchPage = () => import('@/views/pc/PcSearchPage.vue')
const PcShopNewPage = () => import('@/views/pc/ShopNewPage.vue')
const PcClubMainPage = () => import('@/views/pc/PcClubMainPage.vue')
const PcPremiumServicePage = () => import('@/views/pc/PcPremiumServicePage.vue')
const PcPremiumCartPage = () => import('@/views/pc/PcPremiumCartPage.vue')
const PcPremiumApplyPage = () => import('@/views/pc/PcPremiumApplyPage.vue')
const PcPremiumApplyCompletePage = () => import('@/views/pc/PcPremiumApplyCompletePage.vue')
const PcPremiumHistoryPage = () => import('@/views/pc/PcPremiumHistoryPage.vue')
// PcEventHubPage 제거: 플랫폼 수준 행사 목록은 존재하지 않음. 동호회 행사는 /pc/club/:clubSeq/events 에서만 접근.

// 모바일 페이지
const GuestHomePage = () => import('@/views/mobile/GuestHomePage.vue')

// 모바일 게시판
const NoticeListPage = () => import('@/views/mobile/board/NoticeListPage.vue')
const NoticeDetailPage = () => import('@/views/mobile/board/NoticeDetailPage.vue')
const NoticeWritePage = () => import('@/views/mobile/board/NoticeWritePage.vue')
const NoticeSearchPage = () => import('@/views/mobile/board/NoticeSearchPage.vue')
const FreeboardListPage = () => import('@/views/mobile/board/FreeboardListPage.vue')
const FreeboardDetailPage = () => import('@/views/mobile/board/FreeboardDetailPage.vue')
const FreeboardWritePage = () => import('@/views/mobile/board/FreeboardWritePage.vue')
const PhotoboardListPage = () => import('@/views/mobile/board/PhotoboardListPage.vue')
const PhotoboardDetailPage = () => import('@/views/mobile/board/PhotoboardDetailPage.vue')
const PhotoboardWritePage = () => import('@/views/mobile/board/PhotoboardWritePage.vue')
const PhotoMonthlyPage = () => import('@/views/mobile/board/PhotoMonthlyPage.vue')
const PhotoboardFeaturedSelectPage = () => import('@/views/mobile/board/PhotoboardFeaturedSelectPage.vue')
const CarpoolListPage = () => import('@/views/mobile/board/CarpoolListPage.vue')
const CarpoolGuestPage = () => import('@/views/mobile/board/CarpoolGuestPage.vue')
const CarpoolHostPage = () => import('@/views/mobile/board/CarpoolHostPage.vue')
const SettlementBoardPage = () => import('@/views/mobile/board/SettlementBoardPage.vue')

// 모바일 행사
const EventHubPage = () => import('@/views/mobile/event/EventHubPage.vue')
const EventListPage = () => import('@/views/mobile/event/EventListPage.vue')
const AttendedEventsPage = () => import('@/views/mobile/event/AttendedEventsPage.vue')
const EventDetailPage = () => import('@/views/mobile/event/EventDetailPage.vue')
const RoundingDetailPage = () => import('@/views/mobile/event/RoundingDetailPage.vue')
const RoundingDetail02Page = () => import('@/views/mobile/event/RoundingDetail02Page.vue')
const EventCreateGeneralPage = () => import('@/views/mobile/event/EventCreateGeneralPage.vue')
const EventCreateRounding01Page = () => import('@/views/mobile/event/EventCreateRounding01Page.vue')
// EventCreateRounding02Page 폐지(2026-07-22 1단계 통합) — step2 라우트는 step1으로 리다이렉트
// ScoreInputPage → score-admin으로 리다이렉트 (통합됨)
// ShinperioSettingPage → score-admin으로 리다이렉트 (통합됨)
const RoundingTeamPage = () => import('@/views/mobile/event/RoundingTeamPage.vue')
const EventNotifyStudioPage = () => import('@/views/mobile/event/EventNotifyStudioPage.vue')
const EventScoreReportListPage = () => import('@/views/mobile/event/EventScoreReportListPage.vue')
const EventScoreReportDetailPage = () => import('@/views/mobile/event/EventScoreReportDetailPage.vue')
const EventRecapListPage = () => import('@/views/mobile/event/EventRecapListPage.vue')
const EventRecapWritePage = () => import('@/views/mobile/event/EventRecapWritePage.vue')
const EventRecapDetailPage = () => import('@/views/mobile/event/EventRecapDetailPage.vue')
const PcEventRecapListPage = () => import('@/views/pc/PcEventRecapListPage.vue')
const PcEventRecapWritePage = () => import('@/views/pc/PcEventRecapWritePage.vue')
const PcEventRecapDetailPage = () => import('@/views/pc/PcEventRecapDetailPage.vue')
const EventScoreAdminPage = () => import('@/views/mobile/event/EventScoreAdminPage.vue')
const AwardManagePage = () => import('@/views/mobile/club/AwardManagePage.vue')
// EventAwardInputPage → score-admin으로 리다이렉트 (통합됨)
const EventWinnersPage = () => import('@/views/mobile/event/EventWinnersPage.vue')
const EventWinnersDetailPage = () => import('@/views/mobile/event/EventWinnersDetailPage.vue')
const EventPostCloseHubPage = () => import('@/views/mobile/event/EventPostCloseHubPage.vue')
// 4차발주 p82: 행사진행 세부메뉴 '공지히스토리' (행사별 발송 이력·실적·수신처)
const EventNoticeHistoryPage = () => import('@/views/mobile/event/EventNoticeHistoryPage.vue')
const EventNoticeHistoryDetailPage = () => import('@/views/mobile/event/EventNoticeHistoryDetailPage.vue')
const EventNoticePage = () => import('@/views/mobile/event/EventNoticePage.vue')
const EventNoticeDetailPage = () => import('@/views/mobile/event/EventNoticeDetailPage.vue')
const EventPhotosPage = () => import('@/views/mobile/event/EventPhotosPage.vue')

// 모바일 회원/동호회
const MemberStatusPage = () => import('@/views/mobile/member/MemberStatusPage.vue')
const MemberInfoPage = () => import('@/views/mobile/member/MemberInfoPage.vue')
const MemberFeeHistoryPage = () => import('@/views/mobile/member/MemberFeeHistoryPage.vue')
const ClubIntroPage = () => import('@/views/mobile/member/ClubIntroPage.vue')
const ClubJoinPage = () => import('@/views/mobile/member/ClubJoinPage.vue')
const ClubJoinCompletePage = () => import('@/views/mobile/member/ClubJoinCompletePage.vue')
const ClubMyAnswersPage = () => import('@/views/mobile/member/ClubMyAnswersPage.vue')
const ClubSettingPage = () => import('@/views/mobile/member/ClubSettingPage.vue')
const ClubMainPage = () => import('@/views/mobile/club/ClubMainPage.vue')
const ClubSearchPage = () => import('@/views/mobile/club/ClubSearchPage.vue')
// @figma-override:F-SCH1 — 통합검색 (10/2본 질문 31 · 2026-10-04)
const SearchPage = () => import('@/views/mobile/search/SearchPage.vue')
const ClubChatPage = () => import('@/views/mobile/club/ClubChatPage.vue')

const PcEventNoticePage = () => import('@/views/pc/PcEventNoticePage.vue')
const PcEventPhotosPage = () => import('@/views/pc/PcEventPhotosPage.vue')

// 모바일 투표
const VoteListPage = () => import('@/views/mobile/vote/VoteListPage.vue')
const VoteDetailPage = () => import('@/views/mobile/vote/VoteDetailPage.vue')
const VoteCreateTextPage = () => import('@/views/mobile/vote/VoteCreateTextPage.vue')
const VoteCreateDatePage = () => import('@/views/mobile/vote/VoteCreateDatePage.vue')

// 모바일 스폰서
const SponsorListPage = () => import('@/views/mobile/sponsor/SponsorListPage.vue')
const SponsorWritePage = () => import('@/views/mobile/sponsor/SponsorWritePage.vue')
const SponsorViewPage = () => import('@/views/mobile/sponsor/SponsorViewPage.vue')

// 모바일 정산
const SettlementListPage = () => import('@/views/mobile/settlement/SettlementListPage.vue')
const SettlementGeneralPage = () => import('@/views/mobile/settlement/SettlementGeneralPage.vue')
const SettlementViewPage = () => import('@/views/mobile/settlement/SettlementViewPage.vue')
const SettlementEditPage = () => import('@/views/mobile/settlement/SettlementEditPage.vue')

// 모바일 뉴스
const NewsPage = () => import('@/views/mobile/news/NewsPage.vue')

// 메뉴 페이지
const MenuPage = () => import('@/views/mobile/MenuPage.vue')

// 비로그인 서비스 소개/가이드
const ServiceGuidePage = () => import('@/views/mobile/guide/ServiceGuidePage.vue')

// 동호회 만들기 플로우
const ClubCreateTermsPage = () => import('@/views/mobile/club-create/ClubCreateTermsPage.vue')
const ClubCreateBasicPage = () => import('@/views/mobile/club-create/ClubCreateBasicPage.vue')
const ClubCreateInfoPage = () => import('@/views/mobile/club-create/ClubCreateInfoPage.vue')
const ClubCreateConfirmPage = () => import('@/views/mobile/club-create/ClubCreateConfirmPage.vue')
const ClubCreateCompletePage = () => import('@/views/mobile/club-create/ClubCreateCompletePage.vue')
const ClubCreatePaymentPage = () => import('@/views/mobile/club-create/ClubCreatePaymentPage.vue')
const ClubCreateSubscriptionChoicePage = () => import('@/views/mobile/club-create/ClubCreateSubscriptionChoicePage.vue')

// 회원가입
const SignupPage = () => import('@/views/mobile/auth/SignupPage.vue')
const SignupFormPage = () => import('@/views/mobile/auth/SignupFormPage.vue')
const CertCallbackPage = () => import('@/views/mobile/auth/CertCallbackPage.vue')
const SignupInfoPage = () => import('@/views/mobile/auth/SignupInfoPage.vue')
const SignupCompletePage = () => import('@/views/mobile/auth/SignupCompletePage.vue')
const SnsCallbackPage = () => import('@/views/mobile/auth/SnsCallbackPage.vue')


// 마이페이지
const MyPage = () => import('@/views/mobile/mypage/MyPage.vue')
const MyClubListPage = () => import('@/views/mobile/mypage/MyClubListPage.vue')
const NotificationListPage = () => import('@/views/mobile/mypage/NotificationListPage.vue')
const NotificationSettingPage = () => import('@/views/mobile/mypage/NotificationSettingPage.vue')
const ClubManagerTransferAcceptPage = () => import('@/views/mobile/mypage/ClubManagerTransferAcceptPage.vue')

// 모바일 성적
const ScorePersonalPage = () => import('@/views/mobile/score/ScorePersonalPage.vue')
const ScoreRankingPage = () => import('@/views/mobile/score/ScoreRankingPage.vue')
const GuinnessPage = () => import('@/views/mobile/score/GuinnessPage.vue')
const HallOfFamePage = () => import('@/views/mobile/score/HallOfFamePage.vue')
const HallOfFameManagePage = () => import('@/views/mobile/score/HallOfFameManagePage.vue')
const GuinnessSettingPage = () => import('@/views/mobile/score/GuinnessSettingPage.vue')
const HallOfFameSettingPage = () => import('@/views/mobile/score/HallOfFameSettingPage.vue')

// 운영진 전용 (총무/부총무/회장)
const ClubAdminSettingsPage = () => import('@/views/mobile/admin/ClubAdminSettingsPage.vue')
const ClubMemberManagePage = () => import('@/views/mobile/admin/ClubMemberManagePage.vue')
const ClubDesignatedMemberPage = () => import('@/views/mobile/admin/ClubDesignatedMemberPage.vue')
const JoinRequestsPage = () => import('@/views/mobile/admin/JoinRequestsPage.vue')
const FeeManagePage = () => import('@/views/mobile/admin/FeeManagePage.vue')
// 4차발주 F-9(통합본 p113): (가칭)재무리포트 — 열람은 전회원, 작성만 운영진
const FinanceReportPage = () => import('@/views/mobile/admin/FinanceReportPage.vue')
const FinanceReportWritePage = () => import('@/views/mobile/admin/FinanceReportWritePage.vue')
const ClubCashWalletPage = () => import('@/views/mobile/admin/ClubCashWalletPage.vue')
const ClubCashTransferPage = () => import('@/views/mobile/admin/ClubCashTransferPage.vue')
const ClubCashChargePage = () => import('@/views/mobile/admin/ClubCashChargePage.vue')
const ClubCashGiftPage = () => import('@/views/mobile/member/ClubCashGiftPage.vue')
const ClubClosePage = () => import('@/views/mobile/member/ClubClosePage.vue')
const ClubCloseConfirmPage = () => import('@/views/mobile/member/ClubCloseConfirmPage.vue')
const ClubCloseSettlementPage = () => import('@/views/mobile/member/ClubCloseSettlementPage.vue')

// 골프장
const GolfCourseSearchPage = () => import('@/views/mobile/golfcourse/GolfCourseSearchPage.vue')
const GolfCourseRankingPage = () => import('@/views/mobile/golfcourse/GolfCourseRankingPage.vue')
const GolfCourseDetailPage = () => import('@/views/mobile/golfcourse/GolfCourseDetailPage.vue')

// 아이디 찾기 / 비밀번호 재설정
const FindIdPage = () => import('@/views/mobile/auth/FindIdPage.vue')
const ResetPasswordPage = () => import('@/views/mobile/auth/ResetPasswordPage.vue')
const DormantReleasePage = () => import('@/views/mobile/auth/DormantReleasePage.vue')

// 마이페이지 - 개인정보/포인트
const ProfileEditPage = () => import('@/views/mobile/mypage/ProfileEditPage.vue')
const PointHistoryPage = () => import('@/views/mobile/mypage/PointHistoryPage.vue')
const PointChargePage = () => import('@/views/mobile/mypage/PointChargePage.vue')
const PointRefundPage = () => import('@/views/mobile/mypage/PointRefundPage.vue')
const PointInfoPage = () => import('@/views/mobile/mypage/PointInfoPage.vue')
const OrderHistoryPage = () => import('@/views/mobile/mypage/OrderHistoryPage.vue')

// 고객센터
const FaqPage = () => import('@/views/mobile/cs/FaqPage.vue')

// 프리미엄 서비스
const PremiumServicePage = () => import('@/views/mobile/premium/PremiumServicePage.vue')
const PremiumCartPage = () => import('@/views/mobile/premium/PremiumCartPage.vue')
const PremiumApplyPage = () => import('@/views/mobile/premium/PremiumApplyPage.vue')
const PremiumApplyCompletePage = () => import('@/views/mobile/premium/PremiumApplyCompletePage.vue')
const PremiumHistoryPage = () => import('@/views/mobile/premium/PremiumHistoryPage.vue')
const InquiryWritePage = () => import('@/views/mobile/cs/InquiryWritePage.vue')
const InquiryListPage = () => import('@/views/mobile/cs/InquiryListPage.vue')
const InquiryDetailPage = () => import('@/views/mobile/cs/InquiryDetailPage.vue')

// 긴급조인
const UrgentJoinListPage = () => import('@/views/mobile/board/UrgentJoinListPage.vue')
const UrgentJoinDetailPage = () => import('@/views/mobile/board/UrgentJoinDetailPage.vue')
const UrgentJoinWritePage = () => import('@/views/mobile/board/UrgentJoinWritePage.vue')

// 카풀 작성 (CarpoolHostPage에서 통합)

// 타모임 대회
const TournamentListPage = () => import('@/views/mobile/event/TournamentListPage.vue')
const TournamentDetailPage = () => import('@/views/mobile/event/TournamentDetailPage.vue')

// 쇼핑몰 / 공동구매
const ShopPage = () => import('@/views/mobile/shop/ShopPage.vue')
const ShopNewPage = () => import('@/views/mobile/shop/ShopNewPage.vue')
const ShopProductDetailPage = () => import('@/views/mobile/shop/ShopProductDetailPage.vue')
const ProductInquiryPage = () => import('@/views/mobile/shop/ProductInquiryPage.vue')
const ShopProductReviewsPage = () => import('@/views/mobile/shop/ShopProductReviewsPage.vue')
const RefundPolicyPage = () => import('@/views/mobile/shop/RefundPolicyPage.vue')

// 법적 공개 페이지
const PrivacyPolicyPage = () => import('@/views/mobile/legal/PrivacyPolicyPage.vue')
const TermsOfServicePage = () => import('@/views/mobile/legal/TermsOfServicePage.vue')
const CartPage = () => import('@/views/mobile/shop/CartPage.vue')
const CheckoutPage = () => import('@/views/mobile/shop/CheckoutPage.vue')
const GroupBuyPage = () => import('@/views/mobile/shop/GroupBuyPage.vue')
const GroupBuyDetailPage = () => import('@/views/mobile/shop/GroupBuyDetailPage.vue')
const ShopReviewsPage = () => import('@/views/mobile/shop/ShopReviewsPage.vue')
const ShopReviewWritePage = () => import('@/views/mobile/shop/ShopReviewWritePage.vue')
const ShopReviewCompletePage = () => import('@/views/mobile/shop/ShopReviewCompletePage.vue')

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: () => {
      // 프리뷰(정적 업로드) 빌드: 강제 라우트 > 강제 surface 로 바로 진입 (기기감지 무시)
      const forcedRoute = import.meta.env.VITE_FORCE_ROUTE
      if (forcedRoute) return forcedRoute
      const forced = import.meta.env.VITE_FORCE_SURFACE
      if (forced === 'pc') return '/pc'
      if (forced === 'mobile') return '/mobile'
      return isMobileDevice() ? '/mobile' : '/pc'
    },
  },
  {
    // 2026-10-02 10/1 슬라이드 78 — «PDF 인쇄» 는 필요 없다(발주처) → 인쇄 화면을 지웠다(§7-B9 도 함께).
    // 예전에 받아 둔 인쇄 주소는 기기에 맞는 상세 화면으로 넘긴다
    path: '/recap-print/:clubCode/:recapId',
    name: 'RecapPrintStandalone',
    redirect: (to) =>
      (isMobileDevice()
        ? `/mobile/club/${to.params.clubCode}/event-recap/${to.params.recapId}`
        : `/pc/club/${to.params.clubCode}/event-recap/${to.params.recapId}`),
  },
  {
    path: '/pc',
    component: PcLayout,
    meta: { requiresAuth: false }, // 메인 페이지는 로그인 불필요
    children: [
      {
        path: '',
        name: 'PcHome',
        component: PcHomePage,
      },
      // PC 전용 라우트는 여기에 추가
      // 비로그인 서비스 소개/가이드 (항목 18 — 로그인/회원가입 유도)
      {
        path: 'guide/:guideKey',
        name: 'PcServiceGuide',
        component: PcServiceGuidePage,
        meta: { requiresAuth: false, requiresClub: false, title: '서비스 소개' },
      },
      {
        path: 'club/create',
        name: 'PcClubCreate',
        component: PcClubCreatePage,
        meta: { requiresAuth: true, title: '동호회 만들기' },
      },
      {
        path: 'club/:clubCode',
        name: 'PcClubMain',
        component: PcClubMainPage,
        /* 2026-09-07 requiresClub 추가 — 모바일과 어긋나 있었다.
           모바일은 부모 라우트에 requiresClub:true 가 있어 비회원을 ClubIntro 로 보내는데,
           PC 는 가드가 없어 **비회원이 동호회 메인에 그대로 들어가** 총무 이름·회원수가 보였다
           (전수검수 20260906115440 CHANNEL_ASYMMETRY · 실측 재현).
           가드는 이미 채널을 구분해 PC 를 PcClubIntro 로 보낸다(§4 블록) — meta 만 없었다. */
        meta: { requiresAuth: false, requiresClub: true, title: '동호회 메인' },
      },
      {
        path: 'club/:clubCode/intro',
        name: 'PcClubIntro',
        component: PcClubIntroPage,
        meta: { requiresAuth: false, title: '동호회 소개' },
      },
      {
        path: 'news',
        name: 'PcNewsList',
        component: PcNewsListPage,
        meta: { requiresAuth: false, title: '이달의 골총비 뉴스' },
      },
      {
        path: 'news/:newsSeq',
        name: 'PcNewsDetail',
        component: PcNewsDetailPage,
        meta: { requiresAuth: false, title: '뉴스 상세' },
      },
      {
        path: 'notice',
        name: 'PcNotice',
        component: PcPlatformNoticePage,
        meta: { requiresAuth: false, title: '골총비 공지사항' },
      },
      {
        path: 'notice/:id(\\d+)',
        name: 'PcNoticeDetail',
        component: PcPlatformNoticeDetailPage,
        meta: { requiresAuth: false, title: '공지사항 상세' },
      },
      {
        path: 'notifications',
        name: 'PcNotifications',
        component: PcNotificationPage,
        meta: { requiresAuth: true, title: '알림' },
      },
      {
        path: 'notifications/setting',
        name: 'PcNotificationSetting',
        component: PcNotificationSettingPage,
        meta: { requiresAuth: true, title: '알림 설정' },
      },
      {
        path: 'club/:clubCode/fee',
        name: 'PcFeeManage',
        component: PcFeeManagePage,
        // 모바일 fee와 동일 — 총무/부총무 전용 (N-6 기부 포함)
        meta: { requiresClub: true, requiresAuth: true, requiresOperator: true, title: '회비관리' },
      },
      {
        // 회원 본인 회비 납부 이력 — 모바일 member/fee-manage(비총무)와 같은 내용 (수정요청 §⑧ P4)
        path: 'club/:clubCode/my-fee',
        name: 'PcMemberFee',
        component: PcMemberFeePage,
        meta: { requiresClub: true, requiresAuth: true, title: '회비 납부 이력' },
      },
      // 4차발주 F-9(p113): 재무리포트 — 발주 "** 전회원에게 노출" 이라 requiresAdmin 을 걸지 않는다
      {
        path: 'club/:clubCode/finance-report',
        name: 'PcFinanceReport',
        component: PcFinanceReportPage,
        meta: { requiresClub: true, requiresAuth: true, title: '재무리포트' },
      },
      {
        path: 'club/:clubCode/finance-report/write',
        name: 'PcFinanceReportWrite',
        component: PcFinanceReportWritePage,
        meta: { requiresClub: true, requiresAuth: true, requiresOperator: true, title: '재무리포트 작성' },
      },
      {
        path: 'club/:clubCode/cash',
        name: 'PcClubCashWallet',
        component: PcClubCashWalletPage,
        meta: { requiresClub: true, requiresAuth: true, requiresOperator: true, title: '골총캐쉬 지갑' },
      },
      {
        path: 'club/:clubCode/members',
        name: 'PcMemberList',
        component: PcMemberListPage,
        meta: { requiresClub: true, requiresAuth: true, title: '회원현황' },
      },
      {
        path: 'club/:clubCode/carpool',
        name: 'PcCarpoolBoard',
        component: PcCarpoolBoardPage,
        meta: { requiresClub: true, requiresAuth: true, title: '카풀게시판' },
      },
      {
        path: 'club/:clubCode/carpool/write',
        name: 'PcCarpoolWrite',
        component: PcCarpoolWritePage,
        meta: { requiresClub: true, requiresAuth: true, title: '카풀 작성' },
      },
      {
        path: 'club/:clubCode/carpool/edit/:boardSeq(\\d+)',
        name: 'PcCarpoolEdit',
        component: PcCarpoolWritePage,
        meta: { requiresClub: true, requiresAuth: true, title: '카풀 수정' },
      },
      {
        path: 'club/:clubCode/settlement',
        name: 'PcSettlementBoard',
        component: PcSettlementBoardPage,
        meta: { requiresClub: true, requiresAuth: true, title: '정산게시판' },
      },
      {
        path: 'club/:clubCode/settlement/create',
        name: 'PcSettlementCreate',
        component: PcSettlementCreatePage,
                // ⚠️ 2026-09-05 §17 PC 화면 검증: 게이트가 없어 **비회원까지 도달**했다. 정산 등록은 쓰기 → 총무·부총무(서버도 isClubAdmin)
        meta: { requiresClub: true, requiresAuth: true, requiresOperator: true, title: '정산하기' },
      },
      {
        path: 'club/:clubCode/events',
        name: 'PcEventList',
        component: PcEventListPage,
        meta: { requiresClub: true, requiresAuth: true, title: '행사 일정' },
      },
      {
        path: 'club/:clubCode/events/create',
        name: 'PcEventCreate',
        component: PcEventCreatePage,
        meta: { requiresClub: true, requiresAuth: true, requiresOperator: true, title: '행사 만들기' },
      },
      {
        path: 'club/:clubCode/events/notice',
        name: 'PcEventNotice',
        component: PcEventNoticePage,
        meta: { requiresClub: true, requiresAuth: true, title: '행사공지' },
      },
      {
        path: 'club/:clubCode/event/:eventSeq/notice-detail',
        name: 'PcEventNoticeDetail',
        component: () => import('@/views/pc/PcEventNoticeDetailPage.vue'),
        meta: { requiresClub: true, requiresAuth: true, title: '행사공지 상세' },
      },
      {
        path: 'club/:clubCode/events/photos',
        name: 'PcEventPhotos',
        component: PcEventPhotosPage,
        meta: { requiresClub: true, requiresAuth: true, title: '행사 사진' },
      },
      {
        path: 'club/:clubCode/events/:eventSeq',
        name: 'PcEventDetail',
        component: PcEventDetailPage,
        // E14(2026-10-13): 화면이 행사 번호를 한 번만 읽는다 — 다른 행사로 옮기면 새로 만든다(PcLayout routeViewKey)
        meta: { requiresClub: true, requiresAuth: true, title: '행사 상세', remountOnPathChange: true },
      },
      {
        path: 'club/:clubCode/event/:eventSeq/notify-studio',
        name: 'PcEventNotifyStudio',
        component: PcEventNotifyStudioPage,
        meta: { requiresClub: true, requiresAuth: true, requiresOperator: true, title: '알림스튜디오' },
      },
      {
        /* @figma-override:add id=F-NH1 — 2026-09-29 PC 공지히스토리(보낸 공지 목록·상세). 모바일에만 있었다.
           권한은 모바일 EventNoticeHistory 와 같다(requiresAdmin = 회장·총무·부총무, 서버 isAdminView 와 일치).
           «수정·보내기» 버튼은 화면에서 총무·부총무에게만 보인다(스튜디오 라우트가 requiresOperator). */
        path: 'club/:clubCode/event/:eventId/notice-history',
        name: 'PcEventNoticeHistory',
        component: () => import('@/views/pc/PcEventNoticeHistoryPage.vue'),
        meta: { requiresClub: true, requiresAuth: true, requiresAdmin: true, title: '공지히스토리' },
      },
      {
        path: 'club/:clubCode/event/:eventId/notice-history/:historySeq',
        name: 'PcEventNoticeHistoryDetail',
        component: () => import('@/views/pc/PcEventNoticeHistoryDetailPage.vue'),
        meta: { requiresClub: true, requiresAuth: true, requiresAdmin: true, title: '공지히스토리' },
      },
      {
        path: 'club/:clubCode/event/:eventSeq/chat',
        name: 'PcEventChat',
        component: PcClubChatPage,
        meta: { requiresClub: true, requiresAuth: true, title: '행사톡방' },
      },
      {
        path: 'club/:clubCode/events/:eventSeq/edit',
        name: 'PcEventEdit',
        component: PcEventCreatePage,
        meta: { requiresClub: true, requiresAuth: true, requiresOperator: true, title: '행사 수정' },
      },
      {
        path: 'club/:clubCode/board',
        redirect: (to) => `/pc/club/${to.params.clubCode}/board/free`,
      },
      {
        path: 'club/:clubCode/board/notice',
        name: 'PcClubBoardNotice',
        component: PcClubBoardPage,
        /* 2026-09-07 requiresClub 추가 — 모바일과 어긋나 있었다(CHANNEL_ASYMMETRY).
           모바일은 부모 라우트의 requiresClub:true 로 비회원을 막는데 PC 는 requiresAuth 뿐이라
           **로그인만 했으면 남의 동호회 공지를 그대로 읽을 수 있었다.**
           바로 위 PcClubMain 에서 고친 것과 같은 누락이다 — 그때는 총무 이름·회원수가 샜다.
           공지는 동호회 «내부» 콘텐츠이므로 소개(intro)와 달리 비회원에게 열지 않는다. */
        meta: { requiresAuth: true, requiresClub: true, title: '공지사항' },
      },
      {
        path: 'club/:clubCode/board/free',
        name: 'PcClubBoardFree',
        component: PcClubBoardPage,
        /* 2026-09-22 requiresClub 추가 — 공지에만 있고 여기엔 없었다(CHANNEL_ASYMMETRY).
           모바일은 부모의 requiresClub:true 로 세 게시판을 한 번에 막는데 PC 는 공지만 막혀
           **비회원이 자유·포토게시판 화면까지 들어갔다.** 2026-09-07 수정이 절반만 됐던 자리다. */
        meta: { requiresAuth: true, requiresClub: true, title: '자유게시판' },
      },
      {
        path: 'club/:clubCode/board/photo',
        name: 'PcClubBoardPhoto',
        component: PcClubBoardPage,
        /* 2026-09-22 requiresClub 추가 — 위 자유게시판과 같은 누락.
           ⛔ 포토는 더 심했다: 서버 `/api/club/{code}/featured/photos` 에 회원 확인이 없어
              화면에 실제 사진 목록이 그려졌다(비로그인도 200). 서버 가드도 함께 넣었다. */
        meta: { requiresAuth: true, requiresClub: true, title: '포토게시판' },
      },
      {
        path: 'club/:clubCode/board/write',
        name: 'PcClubBoardWrite',
        component: PcClubBoardWritePage,
        meta: { requiresClub: true, requiresAuth: true, title: '게시글 작성' },
      },
      {
        path: 'club/:clubCode/board/:boardSeq(\\d+)',
        name: 'PcClubBoardDetail',
        component: PcClubBoardDetailPage,
        meta: { requiresAuth: true, title: '게시글 상세' },
      },
      {
        path: 'club/:clubCode/vote',
        name: 'PcVote',
        component: PcVoteListPage,
        meta: { requiresClub: true, requiresAuth: true, title: '투표' },
      },
      {
        path: 'club/:clubCode/vote/create',
        name: 'PcVoteCreate',
        component: PcVoteCreatePage,
                // ⚠️ 2026-09-05 §17 PC: 게이트가 없어 비회원까지 도달했다. 투표 생성은 총무·부총무만(서버 ClubVoteService 도 동일) — «작성» 버튼이 비회원에게도 보였다
        meta: { requiresClub: true, requiresAuth: true, title: '투표 만들기', requiresOperator: true },
      },
      {
        /* @figma-override:add id=F-70 reason="PC 투표 수정 — 모바일에는 있는데 PC 에는 없었다.
           만들면 고칠 방법이 없어 지우고 다시 만들어야 했고, 그러면 투표 기록도 사라진다.
           모바일과 같이 «만든 사람»만 들어온다(화면의 isMyVote 로 버튼을 가린다)." registry="F-70" */
        path: 'club/:clubCode/vote/edit/:id',
        name: 'PcVoteEdit',
        component: PcVoteCreatePage,
        meta: { requiresClub: true, requiresAuth: true, title: '투표 수정', requiresOperator: true },
      },
      {
        path: 'club/:clubCode/vote/:id',
        name: 'PcVoteDetail',
        component: PcVoteDetailPage,
        meta: { requiresClub: true, requiresAuth: true, title: '투표하기' },
      },
      {
        path: 'club/:clubCode/settings',
        redirect: (to: any) => `/pc/club/${to.params.clubCode}/edit`,
      },
      {
        path: 'club/:clubCode/subscription',
        name: 'PcClubSubscription',
        component: PcClubSubscriptionPage,
                // ⚠️ 2026-09-05 §17 PC 화면 검증: 게이트가 없어 **비회원까지 도달**했다. 모바일 settings/subscription 과 동일 기준(조회는 회장 포함, 쓰기는 서버가 막는다)
        meta: { requiresClub: true, requiresAuth: true, requiresOperator: true, title: '동호회 사용료 결제' },
      },
      {
        path: 'club/:clubCode/mypage',
        name: 'PcClubMyPage',
        component: PcMyPage,
        meta: { requiresClub: true, requiresAuth: true, title: '마이페이지' },
      },
      {
        path: 'login',
        name: 'PcLogin',
        component: PcLoginPage,
        meta: { requiresAuth: false, title: '로그인' },
      },
      {
        path: 'signup',
        name: 'PcSignup',
        component: PcSignupPage,
        meta: { requiresAuth: false, title: '회원가입' },
      },
      {
        path: 'my-clubs',
        name: 'PcMyClubList',
        component: PcMyClubListPage,
        meta: { requiresAuth: true, title: '내 동호회' },
      },
      {
        path: 'mypage',
        name: 'PcMyPage',
        component: PcMyPage,
        meta: { requiresAuth: true, title: '마이페이지' },
      },
      {
        // 총무 이관 요청 수락 (B-07) — 모바일 /mobile/manager-transfer 와 같은 화면 (수정요청 §⑧ P10).
        // 경로는 알림 딥링크(NotificationDeepLinkUtil CLUB_MANAGER_TRANSFER → /pc/manager-transfer)와 같게 둔다
        path: 'manager-transfer',
        name: 'PcManagerTransferAccept',
        component: PcManagerTransferAcceptPage,
        meta: { requiresAuth: true, title: '총무 이관 요청' },
      },
      {
        path: 'customer-service',
        name: 'PcCustomerService',
        redirect: '/pc/customer-service/faq',
        meta: { requiresAuth: false, title: '고객센터' },
      },
      {
        path: 'customer-service/faq',
        name: 'PcCustomerServiceFaq',
        component: PcFaqPage,
        meta: { requiresAuth: false, title: 'FAQ' },
      },
      {
        path: 'customer-service/inquiry',
        name: 'PcCustomerServiceInquiry',
        component: PcInquiryWritePage,
        meta: { requiresAuth: true, title: '1:1 문의하기' },
      },
      {
        path: 'customer-service/history',
        name: 'PcCustomerServiceHistory',
        component: PcInquiryListPage,
        meta: { requiresAuth: true, title: '문의 내역' },
      },
      {
        path: 'customer-service/history/:id',
        name: 'PcCustomerServiceHistoryDetail',
        component: PcInquiryDetailPage,
        meta: { requiresAuth: true, title: '문의 상세' },
      },
      {
        path: 'group-buy',
        name: 'PcGroupBuy',
        component: PcGroupBuyPage,
        meta: { requiresAuth: false, title: '공동구매' },
      },
      {
        path: 'paid-service',
        name: 'PcPaidService',
        component: PcComingSoonPage,
        meta: { requiresAuth: false, title: '프리미엄 서비스' },
      },
      {
        path: 'points',
        name: 'PcPoints',
        component: PcPointsPage,
        meta: { requiresAuth: true, title: '골총캐쉬 현황 및 충전' },
      },
      {
        path: 'points/info',
        name: 'PcPointInfo',
        component: PcPointInfoPage,
        meta: { requiresAuth: false, title: '골총캐쉬 및 적립금이란?' },
      },
      {
        path: 'shop',
        name: 'PcShop',
        component: () => import('@/views/pc/ShopPage.vue'),
        meta: { requiresAuth: false, title: '쇼핑몰' },
      },
      {
        path: 'shop/list',
        name: 'PcShopList',
        component: () => import('@/views/pc/PcShopListPage.vue'),
        meta: { requiresAuth: false, title: '골총비 상품 목록' },
      },
      {
        path: 'shop/product/:productSeq',
        name: 'PcShopProductDetail',
        component: () => import('@/views/pc/ShopProductDetailPage.vue'),
        meta: { requiresAuth: false, title: '상품 상세' },
        alias: '/pc/shop/:productSeq(\\d+)', // v0.2: 레거시 /pc/shop/19 호환
      },
      {
        path: 'shop/product/:productSeq/reviews',
        name: 'PcShopProductReviews',
        component: () => import('@/views/pc/PcShopProductReviewsPage.vue'),
        meta: { requiresAuth: false, title: '리뷰 전체보기' },
      },
      {
        path: 'shop/cart',
        name: 'PcCart',
        component: () => import('@/views/pc/CartPage.vue'),
        meta: { requiresAuth: true, title: '장바구니' },
      },
      {
        // 2026-09-24 찜 목록 (F-WL1) — 장바구니와 같은 층위
        path: 'shop/wishlist',
        name: 'PcWishlist',
        component: () => import('@/views/pc/PcWishlistPage.vue'),
        meta: { requiresAuth: true, title: '찜 목록' },
      },
      {
        path: 'shop/checkout',
        name: 'PcCheckout',
        component: () => import('@/views/pc/CheckoutPage.vue'),
        meta: { requiresAuth: true, title: '주문/결제' },
      },
      {
        path: 'shop/reviews',
        name: 'PcShopReviews',
        component: () => import('@/views/pc/ShopReviewPage.vue'),
        meta: { requiresAuth: true, title: '구매후기' },
      },
      {
        path: 'shop/inquiry',
        name: 'PcShopInquiry',
        component: () => import('@/views/pc/ShopInquiryPage.vue'),
        meta: { requiresAuth: false, title: '상품문의' },
      },
      {
        path: 'shop/refund-policy',
        name: 'PcShopRefundPolicy',
        component: () => import('@/views/pc/ShopRefundPolicyPage.vue'),
        meta: { requiresAuth: false, title: '교환/반품 안내' },
      },
      {
        path: 'shop/group-buy/:id',
        name: 'PcShopGroupBuyDetail',
        component: () => import('@/views/pc/ShopGroupBuyDetailPage.vue'),
        meta: { requiresAuth: false, title: '공동구매 상품상세' },
      },
      {
        path: 'club/:clubCode/scores',
        name: 'PcClubScores',
        component: PcScoreReportListPage,
        meta: { requiresClub: true, requiresAuth: true, title: '성적관리' },
      },
      {
        path: 'club/:clubCode/event-recap',
        name: 'PcEventRecapList',
        component: PcEventRecapListPage,
        meta: { requiresClub: true, requiresAuth: true, title: '결과리포트' },
      },
      {
        path: 'club/:clubCode/event-recap/:eventCode/write',
        name: 'PcEventRecapWrite',
        component: PcEventRecapWritePage,
        meta: { requiresClub: true, requiresAuth: true, requiresOperator: true, title: '결과리포트' },
      },
      {
        path: 'club/:clubCode/event-recap/:recapId',
        name: 'PcEventRecapDetail',
        component: PcEventRecapDetailPage,
        meta: { requiresClub: true, requiresAuth: true, title: '결과리포트' },
      },
      {
        // 인쇄 화면은 지웠다(슬라이드 78) — 예전 주소는 상세로
        path: 'club/:clubCode/event-recap/:recapId/print',
        name: 'PcEventRecapPrint',
        redirect: (to) => `/pc/club/${to.params.clubCode}/event-recap/${to.params.recapId}`,
      },
      {
        path: 'club/:clubCode/event/:eventId/scores',
        name: 'PcScoreReportDetail',
        component: PcScoreReportDetailPage,
        meta: { requiresClub: true, requiresAuth: true, title: '행사성적 리포트' },
      },
      {
        path: 'club/:clubCode/score/personal',
        name: 'PcScorePersonal',
        component: PcScorePersonalPage,
        meta: { requiresClub: true, requiresAuth: true, title: '개인별 성적관리' },
      },
      {
        path: 'club/:clubCode/score/ranking',
        name: 'PcScoreRanking',
        component: PcScoreRankingPage,
        meta: { requiresClub: true, requiresAuth: true, title: '회원별 랭킹' },
      },
      {
        path: 'club/:clubCode/event-winners',
        name: 'PcEventWinners',
        component: PcEventWinnersPage,
        meta: { requiresClub: true, requiresAuth: true, title: '행사 수상자' },
      },
      {
        path: 'club/:clubCode/event/:eventSeq/winners',
        name: 'PcEventWinnersDetail',
        component: PcEventWinnersDetailPage,
        meta: { requiresClub: true, requiresAuth: true, title: '행사 수상자' },
      },
      {
        path: 'club/:clubCode/event/:eventSeq/score-admin',
        name: 'PcEventScoreAdmin',
        component: PcEventScoreAdminPage,
        // 모바일 score-admin과 동일 — 총무/부총무 전용
        meta: { requiresClub: true, requiresAuth: true, requiresOperator: true, title: '성적/시상 관리' },
      },
      {
        path: 'club/:clubCode/event/:eventSeq/post-close',
        name: 'PcEventPostCloseHub',
        component: PcEventPostCloseHubPage,
        // 운영현황 조회는 회장 포함, 쓰기 버튼은 각 화면에서 operator로 제한
        meta: { requiresClub: true, requiresAuth: true, requiresAdmin: true, title: '행사진행' },
      },
      {
        path: 'club/:clubCode/event/rounding/:eventSeq/participation',
        name: 'PcRoundingParticipation',
        component: PcRoundingParticipationPage,
        meta: { requiresClub: true, requiresAuth: true, title: '참가·승인 현황' },
      },
      {
        path: 'club/:clubCode/hall-of-fame',
        name: 'PcHallOfFame',
        component: PcHallOfFamePage,
        meta: { requiresClub: true, requiresAuth: true, title: '명예의 전당' },
      },
      {
        path: 'club/:clubCode/guinness',
        name: 'PcGuinness',
        component: PcGuinnessPage,
        meta: { requiresClub: true, requiresAuth: true, title: '기네스' },
      },
      // 2026-05-10 P2-③ ADMIN 운영 화면 (memory: feature_pc_guinness_hof_admin.md)
      {
        path: 'club/:clubCode/guinness/setting',
        name: 'PcGuinnessSetting',
        component: PcGuinnessSettingPage,
                // ⚠️ 2026-09-05 §17 PC: 게이트가 없어 비회원까지 도달했다. 기네스 «설정» 화면 — 운영진 전용
        meta: { requiresClub: true, requiresAuth: true, title: '기네스 설정', requiresOperator: true },
      },
      {
        path: 'club/:clubCode/hall-of-fame/manage',
        name: 'PcHallOfFameManage',
        component: PcHallOfFameManagePage,
                // ⚠️ 2026-09-05 §17 PC: 게이트가 없어 비회원까지 도달했다. 명예의전당 «관리» 화면 — 운영진 전용
        meta: { requiresClub: true, requiresAuth: true, title: '명예의 전당 관리', requiresOperator: true },
      },
      {
        path: 'club/:clubCode/hall-of-fame/setting',
        name: 'PcHallOfFameSetting',
        component: PcHallOfFameSettingPage,
        // A02(2026-10-13): 설정 토글은 서버가 운영진만 허용(ScoreApiController.denyIfNotClubAdmin) — 모바일·PC LNB 와 같게 게이트
        meta: { requiresClub: true, requiresAuth: true, title: '명예의 전당 설정', requiresOperator: true },
      },
      {
        path: 'club/:clubCode/chat',
        name: 'PcClubChat',
        component: PcClubChatPage,
        meta: { requiresClub: true, requiresAuth: true, title: '동호회톡방' },
      },
      {
        path: 'club/:clubCode/tournament',
        name: 'PcClubTournament',
        component: PcTournamentListPage,
        meta: { requiresClub: true, requiresAuth: true, title: '타모임과의 대회' },
      },
      {
        path: 'club/:clubCode/tournament/:id',
        name: 'PcClubTournamentDetail',
        component: PcTournamentDetailPage,
        meta: { requiresClub: true, requiresAuth: true, title: '타모임과의 대회' },
      },
      {
        path: 'tournament',
        name: 'PcTournament',
        component: PcTournamentListPage,
        meta: { requiresAuth: false, title: '타모임과의 대회' },
      },
      {
        path: 'tournament/:id',
        name: 'PcTournamentDetail',
        component: PcTournamentDetailPage,
        meta: { requiresAuth: false, title: '타모임과의 대회' },
      },
      // === PC 준비중 라우트 (Mobile에만 구현된 기능) ===
      // 인증 관련
      {
        path: 'find-id',
        name: 'PcFindId',
        component: PcFindIdPage,
        meta: { requiresAuth: false, title: '아이디 찾기' },
      },
      {
        path: 'reset-password',
        name: 'PcResetPassword',
        component: PcFindIdPage,
        meta: { requiresAuth: false, title: '비밀번호 재설정' },
      },
      // 통합검색 — 상단 «검색» 아이콘 (10/2본 질문 31 · 2026-10-04, @figma-override:F-SCH1)
      {
        path: 'search',
        name: 'PcSearch',
        component: PcSearchPage,
        meta: { requiresAuth: false, title: '통합검색' },
      },
      // 동호회 검색/가입
      {
        path: 'club/search',
        name: 'PcClubSearch',
        component: PcClubSearchPage,
        meta: { requiresAuth: false, title: '동호회 찾기' },
      },
      {
        path: 'club/:clubCode/join',
        name: 'PcClubJoin',
        component: PcClubJoinPage,
        meta: { requiresAuth: true, title: '동호회 가입' },
      },
      {
        path: 'club/:clubCode/join-complete',
        name: 'PcClubJoinComplete',
        component: PcClubJoinCompletePage,
        meta: { requiresAuth: true, requiresClub: false, title: '가입 신청 완료' },
      },
      {
        path: 'club/:clubCode/my-answers',
        name: 'PcClubMyAnswers',
        component: PcClubMyAnswersPage,
        meta: { requiresAuth: true, title: '가입 답변 수정' },
      },
      {
        path: 'club/:clubCode/edit',
        name: 'PcClubEdit',
        component: PcClubEditPage,
                // ⚠️ 2026-09-05 §17 PC 화면 검증: 게이트가 없어 **비회원까지 도달**했다. 동호회 수정·가입질문·폐쇄는 전부 쓰기 → 총무·부총무(C-21)
        meta: { requiresClub: true, requiresAuth: true, requiresOperator: true, title: '동호회 정보 수정' },
      },
      // 동호회 회원 상세
      {
        path: 'club/:clubCode/member/:userSeq',
        name: 'PcMemberDetail',
        component: PcMemberDetailPage,
        meta: { requiresClub: true, requiresAuth: true, title: '회원 상세' },
      },
      // 동호회 관리자
      {
        path: 'club/:clubCode/admin/settings',
        redirect: (to: any) => `/pc/club/${to.params.clubCode}/edit`,
      },
      {
        path: 'club/:clubCode/admin/members',
        name: 'PcClubAdminMembers',
        component: PcMemberListPage,
                // ⚠️ 2026-09-05 §17 PC: 게이트가 없어 비회원까지 도달했다. «회원 관리»(강제탈퇴·명부 추가)는 운영 화면이다. 조회용 /members 와 다르다
        meta: { requiresClub: true, requiresAuth: true, title: '회원 관리', requiresOperator: true },
      },
      {
        path: 'club/:clubCode/admin/join-requests',
        name: 'PcClubJoinRequests',
        component: PcClubJoinRequestsPage,
        meta: { requiresClub: true, requiresAuth: true, requiresOperator: true, title: '가입 신청 관리' },  // 모바일 join-requests 와 대칭(C-21 조회·승인 운영진)
      },
      {
        path: 'club/:clubCode/admin/subscription',
        redirect: (to: any) => `/pc/club/${to.params.clubCode}/edit?tab=subscription`,
      },
      // 카풀 상세
      {
        path: 'club/:clubCode/carpool/:boardSeq(\\d+)',
        name: 'PcCarpoolDetail',
        component: PcCarpoolDetailPage,
        meta: { requiresClub: true, requiresAuth: true, title: '카풀 상세' },
      },
      // 정산 상세
      {
        path: 'club/:clubCode/settlement/:settlementSeq',
        name: 'PcSettlementDetail',
        component: PcSettlementDetailPage,
        meta: { requiresClub: true, requiresAuth: true, title: '정산 상세' },
      },
      // 정산 수정
      {
        path: 'club/:clubCode/settlement/:settlementSeq/edit',
        name: 'PcSettlementEdit',
        component: PcSettlementEditPage,
        // A01(2026-10-13): 정산 수정은 서버가 총무·부총무만 허용(SettlementApiController.isClubAdmin) — 모바일 SettlementEdit 와 쌍
        meta: { requiresClub: true, requiresAuth: true, title: '정산 수정', requiresOperator: true },
      },
      // 스폰서
      {
        path: 'club/:clubCode/sponsor',
        name: 'PcSponsorList',
        component: PcSponsorListPage,
        meta: { requiresClub: true, requiresAuth: true, title: '스폰서' },
      },
      {
        path: 'club/:clubCode/sponsor/write',
        name: 'PcSponsorWrite',
        component: PcSponsorWritePage,
        meta: { requiresClub: true, requiresAuth: true, title: '스폰서 작성' },
      },
      {
        path: 'club/:clubCode/sponsor/:sponsorSeq',
        name: 'PcSponsorView',
        component: PcSponsorViewPage,
        meta: { requiresClub: true, requiresAuth: true, title: '스폰서 상세' },
      },
      {
        path: 'club/:clubCode/sponsor/:sponsorSeq/edit',
        name: 'PcSponsorEdit',
        component: PcSponsorWritePage,
        meta: { requiresClub: true, requiresAuth: true, title: '스폰서 수정' },
      },
      // 시상 관리
      {
        path: 'club/:clubCode/award',
        name: 'PcAwardManage',
        component: PcAwardManagePage,
        // 2026-09-06 전수검수 — requiresOperator 가 빠져 있어 «일반회원이 PC 시상 관리에 도달» 했다.
        // 모바일 AwardManage 는 처음부터 requiresOperator 를 걸고 있었다(같은 기능, 다른 게이트).
        // 실측: 일반회원(user 247)이 /pc/club/{code}/award 에 그대로 진입, 모바일은 operator_required 로 차단.
        // 시상 관리는 «쓰기» 화면이므로 ClubRolePermission 의 운영권한(총무·부총무)이 맞다.
        meta: { requiresClub: true, requiresAuth: true, requiresOperator: true, title: '시상 관리' },
      },
      // 골프장
      {
        path: 'golf-courses',
        name: 'PcGolfCourses',
        component: PcGolfCourseSearchPage,
        meta: { requiresAuth: false, title: '전국 골프장' },
      },
      {
        path: 'golf-courses/ranking',
        name: 'PcGolfCourseRanking',
        component: PcGolfCourseRankingPage,
        meta: { requiresAuth: false, title: '골프장 랭킹' },
      },
      {
        path: 'golf-courses/:id',
        name: 'PcGolfCourseDetail',
        component: PcGolfCourseDetailPage,
        meta: { requiresAuth: false, title: '골프장 상세' },
      },
      // 마이페이지 하위
      {
        path: 'mypage/profile',
        name: 'PcProfileEdit',
        component: PcProfileEditPage,
        meta: { requiresAuth: true, title: '회원정보수정' },
      },
      {
        path: 'mypage/orders',
        name: 'PcOrderHistory',
        component: PcOrderHistoryPage,
        meta: { requiresAuth: true, title: '주문 내역' },
      },
      // 쇼핑몰 추가
      {
        path: 'shop/review/write',
        name: 'PcShopReviewWrite',
        component: PcShopReviewWritePage,
        meta: { requiresAuth: true, title: '리뷰 작성' },
      },
      {
        path: 'shop/new',
        name: 'PcShopNew',
        component: PcShopNewPage,
        meta: { requiresAuth: false, title: '신상품' },
      },
      // 프리미엄 서비스
      {
        path: 'premium',
        name: 'PcPremiumService',
        component: PcPremiumServicePage,
        meta: { requiresAuth: false, title: '프리미엄 서비스' },
      },
      {
        path: 'premium/cart',
        name: 'PcPremiumCart',
        component: PcPremiumCartPage,
        meta: { requiresAuth: true, title: '프리미엄 장바구니' },
      },
      {
        path: 'premium/apply',
        name: 'PcPremiumApply',
        component: PcPremiumApplyPage,
        meta: { requiresAuth: true, title: '프리미엄 서비스 신청하기' },
      },
      {
        path: 'premium/apply/complete',
        name: 'PcPremiumApplyComplete',
        component: PcPremiumApplyCompletePage,
        meta: { requiresAuth: true, title: '프리미엄 서비스 신청 완료' },
      },
      {
        path: 'mypage/premium',
        name: 'PcPremiumHistory',
        component: PcPremiumHistoryPage,
        meta: { requiresAuth: true, requiresClubManagerMember: true, title: '프리미엄 서비스 신청내용' },
      },
      // 법적 페이지
      {
        path: 'privacy-policy',
        name: 'PcPrivacyPolicy',
        component: PcTermsPage,
        meta: { requiresAuth: false, title: '개인정보처리방침' },
      },
      {
        path: 'terms-of-service',
        name: 'PcTermsOfService',
        component: PcTermsPage,
        meta: { requiresAuth: false, title: '이용약관' },
      },
      // 고객센터 레거시 경로 — /pc/cs/* → /pc/customer-service/* redirect
      // (외부 링크 호환을 위해 유지. 정식 경로는 customer-service. 추후 완전 제거 예정)
      {
        path: 'cs/faq',
        redirect: '/pc/customer-service/faq',
      },
      {
        path: 'cs/inquiry',
        redirect: '/pc/customer-service/inquiry',
      },
      // ⛔ PcEventHub(/pc/event) 제거: 플랫폼 행사 허브 불필요. 동호회 행사는 /pc/club/:clubSeq/events.
      {
        path: 'event/urgent-join',
        name: 'PcEventUrgentJoinList',
        component: PcUrgentJoinListPage,
        meta: { requiresAuth: false, title: '양수/양도/물물거래' },
      },
      {
        path: 'event/urgent-join/create',
        name: 'PcEventUrgentJoinCreate',
        component: PcUrgentJoinCreatePage,
        meta: { requiresAuth: true, title: '양수/양도/물물거래 작성' },
      },
      {
        /* @figma-override:add id=F-71 reason="PC 긴급조인 수정 — 모바일에는 있는데 PC 에는 없었다.
           한번 올리면 고칠 방법이 없어 지우고 다시 올려야 했고, 신청자가 붙어 있으면 그것도 잃는다." registry="F-71" */
        path: 'event/urgent-join/edit/:id',
        name: 'PcEventUrgentJoinEdit',
        component: PcUrgentJoinCreatePage,
        meta: { requiresAuth: true, title: '양수/양도/물물거래 수정' },
      },
      {
        path: 'event/urgent-join/:id',
        name: 'PcEventUrgentJoinDetail',
        component: PcUrgentJoinDetailPage,
        /* 2026-09-22 requiresAuth true — 화면은 공개라고 선언했는데 API `GET /{id}` 는 401 이었다.
           상세 SQL 은 CONTACT_NAME·CONTACT_PHONE·ASSEMBLY_PLACE·TEE_TIME·REGISTER_NAME 과
           신청자 목록까지 내려준다 — 비로그인에게 열 수 있는 내용이 아니다.
           목록(공개)은 그대로 두고 화면을 API 에 맞춘다(사용자 확정). */
        meta: { requiresAuth: true, title: '양수/양도/물물거래 상세' },
      },
      // 동호회 커뮤니티 > 양수/양도/물물거래 — 같은 화면을 동호회 LNB 안에서 연다 (2026-09-24 사용자 결정)
      { path: 'club/:clubCode/board/urgent-join', name: 'PcClubUrgentJoinList', component: PcUrgentJoinListPage,
        meta: { requiresClub: true, requiresAuth: true, title: '양수/양도/물물거래' } },
      { path: 'club/:clubCode/board/urgent-join/create', name: 'PcClubUrgentJoinCreate', component: PcUrgentJoinCreatePage,
        meta: { requiresClub: true, requiresAuth: true, title: '양수/양도/물물거래 작성' } },
      { path: 'club/:clubCode/board/urgent-join/edit/:id', name: 'PcClubUrgentJoinEdit', component: PcUrgentJoinCreatePage,
        meta: { requiresClub: true, requiresAuth: true, title: '양수/양도/물물거래 수정' } },
      { path: 'club/:clubCode/board/urgent-join/:id', name: 'PcClubUrgentJoinDetail', component: PcUrgentJoinDetailPage,
        meta: { requiresClub: true, requiresAuth: true, title: '양수/양도/물물거래 상세' } },
    ],
  },
  {
    path: '/mobile',
    component: MobileLayout,
    meta: { requiresAuth: false }, // 메인 페이지는 로그인 불필요
    children: [
      {
        path: '',
        name: 'MobileHome',
        // GuestHome 을 모든 상태(비로그인/로그인/동호회보유)의 단일 메인으로 사용 (2026-06-18)
        component: GuestHomePage,
      },
      // 구 /mobile/guest 진입(북마크 등) → 단일 메인으로 통합
      {
        path: 'guest',
        redirect: { name: 'MobileHome' },
      },
      // QA #7-c — 외부 코드에서 /mobile/home 로 잘못 이동 시 흰 화면 방지용 리다이렉트
      {
        path: 'home',
        redirect: { name: 'MobileHome' },
      },
      // PPT 37·38: 동호회 폐쇄 환불정산 (토큰) — 폐쇄 후에도 접근 가능하도록 club 하위 밖
      {
        path: 'club-close-settlement',
        name: 'ClubCloseSettlement',
        component: ClubCloseSettlementPage,
        meta: { requiresAuth: false, title: '환불정산 확인' },
      },
      // 통합검색 — 상단 «검색» 버튼 (10/2본 질문 31 · 2026-10-04, @figma-override:F-SCH1)
      {
        path: 'search',
        name: 'Search',
        component: SearchPage,
        meta: { requiresAuth: false, requiresClub: false, title: '통합검색' },
      },
      // 동호회 검색
      {
        path: 'club/search',
        name: 'ClubSearch',
        component: ClubSearchPage,
        meta: { requiresAuth: false, requiresClub: false, title: '동호회 찾기' },
      },
      // 동호회 소개
      {
        path: 'club/intro',
        name: 'ClubIntro',
        component: ClubIntroPage,
      },
      // 동호회 가입
      {
        path: 'club/join/:clubCode',
        name: 'ClubJoin',
        component: ClubJoinPage,
        meta: { requiresAuth: true }, // 가입은 로그인 필요
        props: true,
      },
      {
        path: 'club/:clubCode/join-complete',
        name: 'ClubJoinComplete',
        component: ClubJoinCompletePage,
        meta: { requiresAuth: true, requiresClub: false, title: '가입 신청 완료' },
        props: true,
      },
      {
        path: 'club/:clubCode/my-answers',
        name: 'ClubMyAnswers',
        component: ClubMyAnswersPage,
        meta: { requiresAuth: true },
        props: true,
      },
      // 동호회별 상세 페이지
      {
        path: 'club/:clubCode',
        component: defineComponent({
          setup() {
            const route = useRoute()
            return () => h(RouterView, { key: route.path })
          }
        }),
        meta: { requiresClub: true }, // 동호회 회원만 접근 가능
        children: [
          // 동호회 메인 (기본 경로)
          {
            path: '',
            name: 'ClubMain',
            component: ClubMainPage,
          },
          // 동호회 소개 (동호회 컨텍스트)
          {
            path: 'intro',
            name: 'ClubIntroInContext',
            component: ClubIntroPage,
            /* 2026-09-07 requiresClub:false 추가 — PC 와 어긋나 있었다(CHANNEL_ASYMMETRY).
               소개는 «가입 전에 보는» 화면이다. PC(PcClubIntro)는 비회원에게 열려 있는데
               모바일은 부모의 requiresClub:true 를 물려받아 막고, 가드가 다시
               /mobile/club/intro?clubCode=… 로 되돌려보내 한 번 더 튕겼다.
               ⚠️ requiresClub 만이 «머지된 meta» 라 자식의 명시적 false 가 부모를 덮는다
                  (requiresAuth·requiresOperator 는 matched.some 이라 못 덮는다 — core/expect.cjs).
               공지(board/notice)는 내부 콘텐츠라 반대로 PC 쪽을 막았다. 성격이 다르다. */
            meta: { requiresClub: false },
          },
          // 동호회 설정 — 기본정보 수정·가입질문 추가/삭제·동호회 폐쇄가 전부 «쓰기» 다.
          // ⚠️ 2026-09-05 §17 등급별 화면 검증: 게이트가 없어 **일반회원·특별회원도 도달**했고
          //    «질문삭제·질문추가·수정·동호회 폐쇄» 버튼이 그대로 노출됐다(서버는 403 으로 막는다).
          //    바로 옆 'settings'(ClubAdminSettings)에는 게이트가 있는데 이쪽만 빠져 있었다.
          //    쓰기이므로 requiresAdmin(회장 포함)이 아니라 requiresOperator(총무·부총무) 다 — C-21.
          {
            path: 'setting',
            name: 'ClubSetting',
            component: ClubSettingPage,
            meta: { requiresAuth: true, requiresOperator: true },
          },

          // 운영진 전용 메뉴 (총무/부총무/회장)
          {
            path: 'settings',
            name: 'ClubAdminSettings',
            component: ClubAdminSettingsPage,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'members',
            name: 'ClubMemberManage',
            component: ClubMemberManagePage,
            meta: { requiresAuth: true },
          },
          {
            path: 'designated-members',
            name: 'ClubDesignatedMembers',
            component: ClubDesignatedMemberPage,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'join-requests',
            name: 'JoinRequests',
            component: JoinRequestsPage,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'fee',
            name: 'FeeManage',
            component: FeeManagePage,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          // 4차발주 F-9(p113): 재무리포트 — 발주 "** 전회원에게 노출" 이라 requiresAdmin 을 걸지 않는다
          {
            path: 'finance-report',
            name: 'FinanceReport',
            component: FinanceReportPage,
            meta: { requiresAuth: true },
          },
          {
            path: 'finance-report/write',
            name: 'FinanceReportWrite',
            component: FinanceReportWritePage,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'cash',
            name: 'ClubCashWallet',
            component: ClubCashWalletPage,
            meta: { requiresAuth: true, requiresOperator: true, title: '골총캐쉬 지갑' },
          },
          {
            path: 'cash/transfer',
            name: 'ClubCashTransfer',
            component: ClubCashTransferPage,
            meta: { requiresAuth: true, requiresOperator: true, title: '골총캐쉬 이체' },
          },
          {
            path: 'cash/charge',
            name: 'ClubCashCharge',
            component: ClubCashChargePage,
            meta: { requiresAuth: true, requiresOperator: true, title: '동호회 골총캐쉬 충전' },
          },
          {
            // 선물/기부: 일반회원 접근(총무 아님) — requiresAdmin 없음
            path: 'cash/gift',
            name: 'ClubCashGift',
            component: ClubCashGiftPage,
            meta: { requiresAuth: true, title: '선물 / 기부' },
          },
          {
            // 2026-10-14 구독 화면 통합 — «동호회 수정 › 구독관리» 탭 하나로(옛 주소·북마크는 탭으로 보낸다).
            //   종전 ClubSubscriptionPage 는 결제만 하는 별도 화면이라 월/연 구분 문구·결제수단·«이전 구매 복원»이 탭과 어긋났다.
            path: 'settings/subscription',
            name: 'ClubSubscription',
            redirect: (to: any) => ({ path: `/mobile/club/${to.params.clubCode}/setting`, query: { ...to.query, tab: 'subscription' } }),
          },
          {
            path: 'settings/close',
            name: 'ClubClose',
            component: ClubClosePage,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'settings/close/confirm',
            name: 'ClubCloseConfirm',
            component: ClubCloseConfirmPage,
            meta: { requiresAuth: true, requiresOperator: true },
          },

          // 게시판
          {
            path: 'board/notice',
            name: 'NoticeList',
            component: NoticeListPage,
          },
          {
            path: 'board/notice/write',
            name: 'NoticeWrite',
            component: NoticeWritePage,
            meta: { requiresAuth: true },
          },
          {
            path: 'board/notice/edit/:id',
            name: 'NoticeEdit',
            component: NoticeWritePage,
            meta: { requiresAuth: true },
          },
          {
            path: 'board/notice/search',
            name: 'NoticeSearch',
            component: NoticeSearchPage,
          },
          {
            path: 'board/notice/:id',
            name: 'NoticeDetail',
            component: NoticeDetailPage,
          },
          {
            path: 'board/freeboard',
            name: 'FreeboardList',
            component: FreeboardListPage,
          },
          {
            path: 'board/freeboard/write',
            name: 'FreeboardWrite',
            component: FreeboardWritePage,
          },
          {
            path: 'board/freeboard/edit/:id',
            name: 'FreeboardEdit',
            component: FreeboardWritePage,
          },
          {
            path: 'board/freeboard/:id',
            name: 'FreeboardDetail',
            component: FreeboardDetailPage,
            // 인기글(메인)에서 진입한 비회원도 글을 볼 수 있도록 회원 가드 면제
            meta: { requiresClub: false },
          },
          {
            path: 'board/photoboard',
            name: 'PhotoboardList',
            component: PhotoboardListPage,
          },
          {
            path: 'board/photoboard/featured-select',
            name: 'PhotoboardFeaturedSelect',
            component: PhotoboardFeaturedSelectPage,
            /* 2026-09-22 requiresOperator 추가 — 「이달의 포토 선정」은 총무·부총무 전용인데
               가드가 requiresAuth 뿐이라 일반회원도 화면을 열 수 있었다.
               서버 /featured/candidates 도 같은 날 운영진 전용으로 좁혔다. */
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'board/photoboard/write',
            name: 'PhotoboardWrite',
            component: PhotoboardWritePage,
          },
          {
            path: 'board/photoboard/edit/:id',
            name: 'PhotoboardEdit',
            component: PhotoboardWritePage,
          },
          {
            path: 'board/photoboard/:id',
            name: 'PhotoboardDetail',
            component: PhotoboardDetailPage,
            // 인기글(메인)에서 진입한 비회원도 글을 볼 수 있도록 회원 가드 면제
            meta: { requiresClub: false },
          },
          {
            path: 'board/photo-monthly',
            name: 'PhotoMonthly',
            component: PhotoMonthlyPage,
          },
          {
            path: 'board/carpool',
            name: 'CarpoolList',
            component: CarpoolListPage,
          },
          {
            path: 'board/carpool/write',
            name: 'CarpoolWrite',
            component: CarpoolHostPage,
            meta: { requiresAuth: true },
          },
          {
            path: 'board/carpool/edit/:id',
            name: 'CarpoolEdit',
            component: CarpoolHostPage,
            meta: { requiresAuth: true },
          },
          {
            path: 'board/carpool/:id',
            name: 'CarpoolDetail',
            component: CarpoolGuestPage,
          },
          // 긴급조인
          {
            path: 'board/urgent-join',
            name: 'UrgentJoinList',
            component: UrgentJoinListPage,
          },
          {
            path: 'board/urgent-join/write',
            name: 'UrgentJoinWrite',
            component: UrgentJoinWritePage,
            meta: { requiresAuth: true },
          },
          {
            path: 'board/urgent-join/edit/:id',
            name: 'UrgentJoinEdit',
            component: UrgentJoinWritePage,
            meta: { requiresAuth: true },
          },
          {
            path: 'board/urgent-join/:id',
            name: 'UrgentJoinDetail',
            component: UrgentJoinDetailPage,
          },
          {
            path: 'board/settlement',
            name: 'SettlementBoard',
            component: SettlementBoardPage,
          },

          // 회원
          {
            path: 'member/status',
            name: 'MemberStatus',
            component: MemberStatusPage,
            meta: { requiresAuth: true },
          },
          {
            path: 'member/info/:id',
            name: 'MemberInfo',
            component: MemberInfoPage,
            meta: { requiresAuth: true },
          },
          {
            path: 'member/fee/:id',
            name: 'MemberFeeHistory',
            component: MemberFeeHistoryPage,
            meta: { requiresAuth: true },
          },
          {
            // 회비 탭 페이지(회비현황[운영진]/회비 납부[전원]). 일반/회장 진입점 — requiresAdmin 없음.
            path: 'member/fee-manage',
            name: 'MemberFeeManage',
            component: FeeManagePage,
            meta: { requiresAuth: true },
          },

          // 스폰서
          {
            path: 'sponsor',
            name: 'SponsorList',
            component: SponsorListPage,
          },
          {
            path: 'sponsor/write',
            name: 'SponsorWrite',
            component: SponsorWritePage,
            meta: { requiresAuth: true },
          },
          {
            path: 'sponsor/edit/:id',
            name: 'SponsorEdit',
            component: SponsorWritePage,
            meta: { requiresAuth: true },
          },
          {
            path: 'sponsor/view/:id',
            name: 'SponsorView',
            component: SponsorViewPage,
          },

          // 정산
          {
            path: 'settlement',
            name: 'SettlementList',
            component: SettlementListPage,
          },
          {
            path: 'settlement/general',
            name: 'SettlementGeneral',
            component: SettlementGeneralPage,
            // ⚠️ 2026-09-05 §17: 목록의 «정산하기» 버튼만 막고 이 경로는 열려 있었다(직접 진입 가능).
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'settlement/:id',
            name: 'SettlementView',
            component: SettlementViewPage,
            meta: { requiresAuth: true },
          },
          {
            path: 'settlement/:id/edit',
            name: 'SettlementEdit',
            component: SettlementEditPage,
            // A01(2026-10-13): PC PcSettlementEdit 와 쌍 — 서버가 총무·부총무만 허용
            meta: { requiresAuth: true, requiresOperator: true },
          },

          // 행사
          {
            path: 'event',
            name: 'EventList',
            component: EventListPage,
          },
          {
            path: 'event/:eventId/notice-history',
            name: 'EventNoticeHistory',
            component: EventNoticeHistoryPage,
            /* requiresAdmin — 서버가 이미 ClubRolePermission.isAdminView 로 막고 있는데
               라우트만 그걸 선언하지 않아 «들어가지긴 하는데 내용은 오류» 였다.
               2026-09-07 전수검수 실측: 부회장·특별회원·일반회원이 화면까지 들어간 뒤
               「조회 권한이 없습니다. (총무·부총무·회장만 가능)」 를 보게 됐다.
               집합은 서버(PRESIDENT·MANAGER·VICE_MANAGER)와 auth.ts isClubAdmin 이 일치한다. */
            meta: { requiresAuth: true, requiresAdmin: true },
          },
          {
            // 2026-09-29 발주 추가 39 — 보낸 공지 + 수신자 현황(채널별 성공·실패). 권한은 목록과 같다
            path: 'event/:eventId/notice-history/:historySeq',
            name: 'EventNoticeHistoryDetail',
            component: EventNoticeHistoryDetailPage,
            meta: { requiresAuth: true, requiresAdmin: true },
          },
          {
            path: 'event/:eventId/post-close',
            name: 'EventPostCloseHub',
            component: EventPostCloseHubPage,
            meta: { requiresAuth: true, requiresAdmin: true },
          },
          {
            path: 'event/:eventId/chat',
            name: 'EventChat',
            component: ClubChatPage,
            meta: { title: '행사톡방', hideTopHeader: true },
          },
          {
            path: 'event/:id',
            name: 'EventDetail',
            component: EventDetailPage,
          },
          {
            path: 'event/rounding/:id',
            name: 'RoundingDetail',
            component: RoundingDetailPage,
          },
          {
            path: 'event/rounding/:id/participation',
            name: 'RoundingParticipation',
            component: RoundingDetail02Page,
          },
          {
            path: 'event/:id/settlement',
            redirect: to => ({
              path: `/mobile/club/${to.params.clubCode}/settlement/general`,
              query: { eventSeq: to.params.id as string },
            }),
          },
          {
            path: 'event/create',
            redirect: to => ({ name: 'EventCreateRounding01', params: { clubCode: to.params.clubCode } }),
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'event/create/general',
            name: 'EventCreateGeneral',
            component: EventCreateGeneralPage,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'event/create/rounding',
            name: 'EventCreateRounding01',
            component: EventCreateRounding01Page,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            // 2026-07-22 1단계 통합: step2 폐지 → step1로 리다이렉트(북마크/뒤로가기 대비)
            path: 'event/create/rounding/step2',
            name: 'EventCreateRounding02',
            redirect: to => ({ name: 'EventCreateRounding01', params: { clubCode: to.params.clubCode } }),
          },
          // 행사 수정 (등록 페이지 재사용)
          {
            path: 'event/:id/edit',
            name: 'EventEdit',
            component: EventCreateGeneralPage,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'event/rounding/:id/edit',
            name: 'RoundingEdit01',
            component: EventCreateRounding01Page,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            // 2026-07-22 1단계 통합: step2 폐지 → 수정 step1로 리다이렉트
            path: 'event/rounding/:id/edit/step2',
            name: 'RoundingEdit02',
            redirect: to => ({ name: 'RoundingEdit01', params: { clubCode: to.params.clubCode, id: to.params.id } }),
          },
          {
            path: 'event/:eventId/score-input',
            name: 'ScoreInput',
            redirect: (to: any) => `/mobile/club/${to.params.clubCode}/event/${to.params.eventId}/score-admin`,
          },
          {
            path: 'event/:eventId/shinperio',
            name: 'ShinperioSetting',
            redirect: (to: any) => `/mobile/club/${to.params.clubCode}/event/${to.params.eventId}/score-admin`,
          },
          {
            path: 'event/rounding/:eventId/team',
            name: 'RoundingTeam',
            component: RoundingTeamPage,
            // 조편성·청백 배정은 운영진 전용 (N-2)
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            // 4차발주 B-2(통합본 p87): 총무전용 알림스튜디오
            path: 'event/:eventSeq/notify-studio',
            name: 'EventNotifyStudio',
            component: EventNotifyStudioPage,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'score-report',
            name: 'ScoreReportList',
            component: EventScoreReportListPage,
          },
          {
            path: 'event-recap',
            name: 'EventRecapList',
            component: EventRecapListPage,
            meta: { requiresAuth: true },
          },
          {
            path: 'event-recap/:eventCode/write',
            name: 'EventRecapWrite',
            component: EventRecapWritePage,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'event-recap/:recapId',
            name: 'EventRecapDetail',
            component: EventRecapDetailPage,
            meta: { requiresAuth: true },
          },
          {
            // 인쇄 화면은 지웠다(슬라이드 78) — 예전 주소는 상세로
            path: 'event-recap/:recapId/print',
            name: 'EventRecapPrint',
            redirect: (to) => `/mobile/club/${to.params.clubCode}/event-recap/${to.params.recapId}`,
          },
          {
            path: 'event/:eventId/score-report',
            name: 'ScoreReportDetail',
            component: EventScoreReportDetailPage,
          },
          {
            path: 'event/:eventId/score-admin',
            name: 'ScoreAdmin',
            component: EventScoreAdminPage,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'award-manage',
            name: 'AwardManage',
            component: AwardManagePage,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'event/:eventId/award-input',
            name: 'EventAwardInput',
            redirect: (to: any) => `/mobile/club/${to.params.clubCode}/event/${to.params.eventId}/score-admin`,
          },
          {
            path: 'event/:eventId/winners',
            name: 'EventWinnersDetail',
            component: EventWinnersDetailPage,
          },

          // 투표
          {
            path: 'vote',
            name: 'VoteList',
            component: VoteListPage,
          },
          {
            path: 'vote/create/text',
            name: 'VoteCreateText',
            component: VoteCreateTextPage,
            // A03(2026-10-13): 수정(VoteEdit)·PC 와 같게 — 서버 assertVoteOperator 가 운영진만 허용
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'vote/create/date',
            name: 'VoteCreateDate',
            component: VoteCreateDatePage,
            // A03(2026-10-13): VoteCreateText 와 같다
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'vote/edit/:id',
            name: 'VoteEdit',
            component: VoteCreateTextPage,
            /* ⛔ 2026-09-12 — requiresOperator 가 빠져 있었다.
               서버는 투표 수정을 **운영진 전용**으로 막는다(VoteApiController.assertVoteOperator).
               게이트가 없으니 일반회원이 수정 화면까지 들어간 뒤 저장할 때만 막혔다 — 헛걸음이다.
               PC(PcVoteEdit)는 처음부터 requiresOperator 를 걸고 있었다(같은 기능, 다른 게이트).
               실측: 회장·특별회원·일반회원 3등급에서 «모바일 열림 / PC 막힘» 비대칭. */
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'vote/:id',
            name: 'VoteDetail',
            component: VoteDetailPage,
          },

          // 성적
          {
            path: 'score/personal',
            name: 'ScorePersonal',
            component: ScorePersonalPage,
            meta: { requiresAuth: true },
          },
          {
            path: 'score/ranking',
            name: 'ScoreRanking',
            component: ScoreRankingPage,
          },
          {
            path: 'score/guinness',
            name: 'ScoreGuinness',
            component: GuinnessPage,
          },
          {
            path: 'score/guinness/setting',
            name: 'ScoreGuinnessSetting',
            component: GuinnessSettingPage,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'score/hall-of-fame',
            name: 'ScoreHallOfFame',
            component: HallOfFamePage,
          },
          {
            path: 'score/hall-of-fame/manage',
            name: 'ScoreHallOfFameManage',
            component: HallOfFameManagePage,
            meta: { requiresAuth: true, requiresOperator: true },
          },
          {
            path: 'score/hall-of-fame/setting',
            name: 'ScoreHallOfFameSetting',
            component: HallOfFameSettingPage,
            meta: { requiresAuth: true, requiresOperator: true },
          },

          // 행사공지 / 수상자 / 사진
          {
            path: 'events/notice',
            name: 'EventsNotice',
            component: EventNoticePage,
            meta: { title: '행사공지' },
          },
          {
            path: 'event/:eventSeq/notice-detail',
            name: 'EventNoticeDetail',
            component: EventNoticeDetailPage,
            meta: { title: '행사공지 상세' },
          },
          {
            path: 'events/winners',
            name: 'EventsWinners',
            component: EventWinnersPage,
            meta: { title: '행사 수상자' },
          },
          {
            path: 'events/photos',
            name: 'EventsPhotos',
            component: EventPhotosPage,
            meta: { title: '행사 사진' },
          },

          // 채팅 (자체 풀스크린 헤더 + height:100dvh → 공통 상단헤더 숨김)
          {
            path: 'chat',
            name: 'ClubChat',
            component: ClubChatPage,
            meta: { title: '동호회톡방', hideTopHeader: true },
          },

          // 타모임과의 대회
          {
            path: 'tournament',
            name: 'TournamentList',
            component: TournamentListPage,
          },
          {
            path: 'tournament/:id',
            name: 'TournamentDetail',
            component: TournamentDetailPage,
          },
        ],
      },
      // 플랫폼 공지사항 (동호회 가입 불필요)
      {
        path: 'notice',
        name: 'PlatformNotice',
        component: () => import('@/views/mobile/board/PlatformNoticePage.vue'),
        meta: { requiresClub: false },
      },
      {
        path: 'notice/:id',
        name: 'PlatformNoticeDetail',
        component: () => import('@/views/mobile/board/PlatformNoticeDetailPage.vue'),
        meta: { requiresClub: false },
      },
      // 내가 가입한 동호회 목록 (BottomNav에서 접근)
      {
        path: 'clubs',
        name: 'MyClubs',
        component: MyClubListPage,
        meta: { requiresAuth: true, requiresClub: false, guestRedirect: '/mobile/guide/service' },
      },
      // 뉴스
      {
        path: 'news',
        name: 'News',
        component: NewsPage,
        meta: { requiresClub: false },
      },
      {
        path: 'news/:id',
        name: 'NewsDetail',
        component: () => import('@/views/mobile/news/NewsDetailPage.vue'),
        meta: { requiresAuth: false, requiresClub: false },
      },
      // 골프장 검색
      {
        path: 'golf-courses',
        name: 'GolfCourseSearch',
        component: GolfCourseSearchPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'golf-courses/ranking',
        name: 'GolfCourseRanking',
        component: GolfCourseRankingPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'golf-courses/:courseId',
        name: 'GolfCourseDetail',
        component: GolfCourseDetailPage,
        props: true,
        meta: { requiresAuth: false, requiresClub: false },
      },
      // 메뉴
      {
        path: 'menu',
        name: 'Menu',
        component: MenuPage,
        meta: { requiresClub: false },
      },
      // 비로그인 서비스 소개/가이드 (항목 18 — 로그인/회원가입 유도)
      {
        path: 'guide/:guideKey',
        name: 'ServiceGuide',
        component: ServiceGuidePage,
        meta: { requiresAuth: false, requiresClub: false, title: '서비스 소개' },
      },
      // 동호회 만들기 플로우
      {
        path: 'club-create/terms',
        name: 'ClubCreateTerms',
        component: ClubCreateTermsPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'club-create/basic',
        name: 'ClubCreateBasic',
        component: ClubCreateBasicPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'club-create/info',
        name: 'ClubCreateInfo',
        component: ClubCreateInfoPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'club-create/subscription',
        name: 'ClubCreateSubscriptionChoice',
        component: ClubCreateSubscriptionChoicePage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'club-create/confirm',
        name: 'ClubCreateConfirm',
        component: ClubCreateConfirmPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'club-create/complete',
        name: 'ClubCreateComplete',
        component: ClubCreateCompletePage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'club-create/payment',
        name: 'ClubCreatePayment',
        component: ClubCreatePaymentPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      // 로그인
      {
        path: 'login',
        name: 'Login',
        component: LoginPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      // 회원가입 (소셜/자체 가입 선택 화면)
      {
        path: 'signup',
        name: 'Signup',
        component: SignupPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      // 회원가입 - 아이디/비밀번호/이용약관
      {
        path: 'signup/form',
        name: 'SignupForm',
        component: SignupFormPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      // 본인인증 redirect 콜백 (RN WebView)
      {
        path: 'cert-callback',
        name: 'CertCallback',
        component: CertCallbackPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      // 회원가입 - 상세정보 입력
      {
        path: 'signup/info',
        name: 'SignupInfo',
        component: SignupInfoPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      // 회원가입 - 완료
      {
        path: 'signup/complete',
        name: 'SignupComplete',
        component: SignupCompletePage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      // 아이디 찾기
      {
        path: 'find-id',
        name: 'FindId',
        component: FindIdPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      // 비밀번호 재설정
      {
        path: 'reset-password',
        name: 'ResetPassword',
        component: ResetPasswordPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'dormant',
        name: 'DormantRelease',
        component: DormantReleasePage,
        meta: { requiresAuth: false, requiresClub: false, title: '휴면 해제' },
      },
      // 마이페이지
      {
        path: 'mypage',
        name: 'MyPage',
        component: MyPage,
        meta: { requiresAuth: true, requiresClub: false, guestRedirect: '/mobile/guide/service' },
      },
      {
        path: 'mypage/clubs',
        name: 'MyClubList',
        component: MyClubListPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      // 회원정보수정
      {
        path: 'mypage/profile',
        name: 'ProfileEdit',
        component: ProfileEditPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      // 포인트 안내
      {
        path: 'point/info',
        name: 'PointInfo',
        component: PointInfoPage,
        meta: { requiresAuth: false, requiresClub: false, title: '골총캐쉬 및 적립금이란?' },
      },
      // 프리미엄 서비스
      {
        path: 'premium',
        name: 'PremiumService',
        component: PremiumServicePage,
        meta: { requiresAuth: false, requiresClub: false, title: '프리미엄 서비스' },
      },
      {
        path: 'premium/cart',
        name: 'PremiumCart',
        component: PremiumCartPage,
        meta: { requiresAuth: true, requiresClub: false, title: '프리미엄 장바구니' },
      },
      {
        path: 'premium/apply',
        name: 'PremiumApply',
        component: PremiumApplyPage,
        meta: { requiresAuth: true, requiresClub: false, title: '프리미엄 서비스 신청' },
      },
      {
        path: 'premium/apply/complete',
        name: 'PremiumApplyComplete',
        component: PremiumApplyCompletePage,
        meta: { requiresAuth: true, requiresClub: false, title: '신청 완료' },
      },
      {
        path: 'mypage/premium',
        name: 'PremiumHistory',
        component: PremiumHistoryPage,
        meta: { requiresAuth: true, requiresClub: false, requiresClubManagerMember: true, title: '프리미엄 서비스 신청내용' },
      },
      // 포인트
      {
        path: 'mypage/point',
        name: 'PointHistory',
        component: PointHistoryPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'mypage/point/charge',
        name: 'PointCharge',
        component: PointChargePage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'mypage/point/refund',
        name: 'PointRefund',
        component: PointRefundPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      // 주문 내역
      {
        path: 'mypage/orders',
        name: 'OrderHistory',
        component: OrderHistoryPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      // 알림
      {
        path: 'notifications',
        name: 'NotificationList',
        component: NotificationListPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'notifications/setting',
        name: 'NotificationSetting',
        component: NotificationSettingPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      // 총무 이관 요청 수락 (B-07)
      {
        path: 'manager-transfer',
        name: 'ClubManagerTransferAccept',
        component: ClubManagerTransferAcceptPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      // 고객센터
      {
        path: 'cs/faq',
        name: 'Faq',
        component: FaqPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'cs/inquiry/write',
        name: 'InquiryWrite',
        component: InquiryWritePage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'cs/inquiry',
        name: 'InquiryList',
        component: InquiryListPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'cs/inquiry/:id',
        name: 'InquiryDetail',
        component: InquiryDetailPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      // 쇼핑몰
      {
        path: 'shop',
        name: 'Shop',
        component: ShopPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'shop/new',
        name: 'ShopNew',
        component: ShopNewPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'shop/list',
        name: 'ShopList',
        component: () => import('@/views/mobile/shop/ShopListPage.vue'),
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'shop/product/:id',
        name: 'ShopProductDetail',
        component: ShopProductDetailPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'shop/product/:id/reviews',
        name: 'ShopProductReviews',
        component: ShopProductReviewsPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'shop/product/:productSeq/inquiry',
        name: 'ProductInquiry',
        component: ProductInquiryPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'shop/refund-policy',
        name: 'RefundPolicy',
        component: RefundPolicyPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      // 법적 공개 페이지 (Google OAuth 등록용)
      {
        path: 'privacy-policy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicyPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'terms-of-service',
        name: 'TermsOfService',
        component: TermsOfServicePage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'shop/cart',
        name: 'Cart',
        component: CartPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        // 2026-09-24 찜 목록 (F-WL1) — 장바구니와 같은 층위
        path: 'shop/wishlist',
        name: 'Wishlist',
        component: () => import('@/views/mobile/shop/WishlistPage.vue'),
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'shop/checkout',
        name: 'Checkout',
        component: CheckoutPage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'shop/reviews',
        name: 'ShopReviews',
        component: ShopReviewsPage,
        meta: { requiresAuth: true, requiresClub: false, title: '쇼핑몰 구매후기' },
      },
      {
        path: 'shop/review/write',
        name: 'ShopReviewWrite',
        component: ShopReviewWritePage,
        meta: { requiresAuth: true, requiresClub: false, title: '리뷰 작성하기' },
      },
      {
        path: 'shop/review/complete/:reviewId',
        name: 'ShopReviewComplete',
        component: ShopReviewCompletePage,
        meta: { requiresAuth: true, requiresClub: false, title: '리뷰 작성 완료' },
      },
      {
        path: 'shop/group-buy',
        name: 'GroupBuy',
        component: GroupBuyPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'shop/group-buy/:id',
        name: 'GroupBuyDetail',
        component: GroupBuyDetailPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      // 이벤트 허브 (공동구매 + 대회 + 긴급조인 종합)
      {
        path: 'event',
        name: 'EventHub',
        component: EventHubPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      // 지난행사 목록·검색 (항목 13) — 내가 참석한 완료 행사
      {
        path: 'events/attended',
        name: 'AttendedEvents',
        component: AttendedEventsPage,
        meta: { requiresAuth: true, requiresClub: false, title: '지난행사' },
      },
      // 플랫폼 이벤트 (동호회 컨텍스트 불필요, 누구나 접근 가능)
      {
        path: 'event/group-buy',
        name: 'EventGroupBuy',
        redirect: { name: 'GroupBuy' },
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'event/urgent-join',
        name: 'EventUrgentJoinList',
        component: UrgentJoinListPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'event/urgent-join/write',
        name: 'EventUrgentJoinWrite',
        component: UrgentJoinWritePage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'event/urgent-join/edit/:id',
        name: 'EventUrgentJoinEdit',
        component: UrgentJoinWritePage,
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'event/urgent-join/:id',
        name: 'EventUrgentJoinDetail',
        component: UrgentJoinDetailPage,
        /* 2026-09-22 requiresAuth true — 화면은 공개라고 선언했는데 API `GET /{id}` 는 401 이었다.
           상세 SQL 은 CONTACT_NAME·CONTACT_PHONE·ASSEMBLY_PLACE·TEE_TIME·REGISTER_NAME 과
           신청자 목록까지 내려준다 — 비로그인에게 열 수 있는 내용이 아니다.
           목록(공개)은 그대로 두고 화면을 API 에 맞춘다(사용자 확정). */
        meta: { requiresAuth: true, requiresClub: false },
      },
      {
        path: 'event/tournament',
        name: 'EventTournamentList',
        component: TournamentListPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'event/tournament/:id',
        name: 'EventTournamentDetail',
        component: TournamentDetailPage,
        meta: { requiresAuth: false, requiresClub: false },
      },
      // 개발자 도구
      {
        path: 'dev/icons',
        name: 'IconCatalog',
        component: () => import('@/views/dev/IconCatalogPage.vue'),
        meta: { requiresAuth: false, requiresClub: false },
      },
      {
        path: 'dev/components',
        name: 'ComponentCatalog',
        component: () => import('@/views/dev/ComponentCatalogPage.vue'),
        meta: { requiresAuth: false, requiresClub: false },
      },
    ],
  },
  // SNS 콜백: 레이아웃 없이 독립 렌더링
  {
    path: '/pc/auth/sns/callback',
    name: 'PcSnsCallback',
    component: () => import('@/views/pc/PcSnsCallbackPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/mobile/auth/sns/callback',
    name: 'SnsCallback',
    component: SnsCallbackPage,
    meta: { requiresAuth: false, requiresClub: false },
  },
  // 4차발주 2편 p115(R-2-115-1): 기기중립 공유 진입점.
  // 공유 링크가 /mobile/... 로 고정돼 있어 PC 에서 열면 모바일 화면이 떴다.
  // 공유는 이 경로로 만들고, 여는 기기에 맞는 실제 화면으로 넘긴다.
  // 2026-10-02 10/1 슬라이드 78 — 결과리포트 링크(알림스튜디오 발송 본문)도 기기 중립으로. 행사 번호로 찾아 상세로 간다
  {
    path: '/go/recap/:clubCode/:eventSeq',
    name: 'GoRecap',
    redirect: (to) =>
      (isMobileDevice()
        ? `/mobile/club/${to.params.clubCode}/event-recap?event=${to.params.eventSeq}`
        : `/pc/club/${to.params.clubCode}/event-recap?event=${to.params.eventSeq}`),
  },
  // 2026-10-02 10/1 §7-D7 — 행사 공유 링크도 기기 중립으로(PC 알림스튜디오가 /pc/… 를, 행사 확정 모달이 /mobile/… 를 박아 넣었다)
  {
    path: '/go/event/:clubCode/:id',
    name: 'GoEvent',
    redirect: (to) =>
      (isMobileDevice()
        ? `/mobile/club/${to.params.clubCode}/event/${to.params.id}`
        : `/pc/club/${to.params.clubCode}/events/${to.params.id}`),
  },
  // 2026-10-09 10/7본 120번 장 — 게시글 공유 미리보기(/api/share/board/…)가 사람을 여기로 넘긴다. t = 게시판 유형
  {
    path: '/go/board/:clubCode/:boardSeq(\\d+)',
    name: 'GoBoard',
    redirect: (to) => {
      const { clubCode, boardSeq } = to.params
      // query: {} — 유형 표시(t)를 도착 주소에 남기지 않는다
      if (!isMobileDevice()) return { path: `/pc/club/${clubCode}/board/${boardSeq}`, query: {} }
      const t = String(to.query.t || '')
      const kind = t === 'NOTICE' || t === 'EVENT_NOTICE' ? 'notice' : t === 'PHOTO' ? 'photoboard' : 'freeboard'
      return { path: `/mobile/club/${clubCode}/board/${kind}/${boardSeq}`, query: {} }
    },
  },
  {
    path: '/go/vote/:clubCode/:id',
    name: 'GoVote',
    redirect: (to) =>
      (isMobileDevice()
        ? `/mobile/club/${to.params.clubCode}/vote/${to.params.id}`
        : `/pc/club/${to.params.clubCode}/vote/${to.params.id}`),
  },
  // 매칭되지 않는 모든 경로 (라우트 미스매치 시 흰화면 방지).
  // 종전엔 무조건 MobileHome 이었다 — MobileHome 의 부모가 MobileLayout 이라
  // PC 브라우저에서 잘못된 /pc/* 경로를 열면 모바일 앱셸(BottomNavBar·mobile-scroll)이
  // 떴다. PC 화면에 모바일을 띄우지 않는다는 원칙(PC-01)에 어긋난다. 2026-09-03 수정.
  // 위 GoVote 와 같은 기기 분기를 쓴다.
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: (to) => {
      const path = String(to.path)
      if (path === '/pc' || path.startsWith('/pc/')) return '/pc'
      return isMobileDevice() ? { name: 'MobileHome' } : '/pc'
    },
  },
]

const router = createRouter({
  // 프리뷰(정적 업로드) 빌드만 hash 라우팅 — 서버 SPA fallback 없이도 딥링크/새로고침 동작.
  // 운영/개발/로컬은 기존 history 모드 유지.
  history: import.meta.env.VITE_PREVIEW === '1' ? createWebHashHistory() : createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  },
})

const isInRnWebView = (): boolean => typeof window !== 'undefined' && !!(window as any).ReactNativeWebView
/** 이 문서의 첫 네비게이션인가 — 앱 토큰 주입 대기는 첫 이동에서만 한다 */
let rnFirstNav = true
/** 앱이 localStorage 에 토큰을 넣을 때까지 최대 timeoutMs 기다린다 */
const waitForRnInjectedToken = (timeoutMs: number): Promise<string | null> =>
  new Promise((resolve) => {
    const started = Date.now()
    const tick = () => {
      const t = localStorage.getItem('accessToken')
      if (t) return resolve(t)
      if (Date.now() - started >= timeoutMs) return resolve(null)
      setTimeout(tick, 100)
    }
    tick()
  })

/**
 * 앱(RN WebView) 토큰 감시 — 이미 떠 있는 탭 WebView 에 앱이 토큰을 넣어도(로그인 브로드캐스트·onLoadEnd 주입)
 * localStorage 만 바뀌고 화면 상태(auth store)는 그대로라, 가이드로 보내진 탭이 계속 «비로그인» 으로 남았다.
 * 토큰이 새로 보이면 store 를 맞추고, 가이드로 돌린 화면이면(from) 원래 가려던 곳으로 되돌린다.
 */
if (isInRnWebView()) {
  window.setInterval(() => {
    try {
      const t = localStorage.getItem('accessToken')
      if (!t) return
      const store = useAuthStore()
      if (store.isAuthenticated) return
      store.setTokens(t, localStorage.getItem('refreshToken') || '')
      const from = router.currentRoute.value.query.from
      if (typeof from === 'string' && from.startsWith('/mobile/')) router.replace(from)
    } catch (e) {
      console.warn('[router] RN 토큰 감시 실패', e) // v12-ok: 백그라운드 동기화 — 다음 주기에 다시 시도
    }
  }, 700)
}

/**
 * 앱(RN) 하단 탭을 누르면 그 탭의 첫 화면으로 — 2026-10-06 통화 §2-1.
 *
 * ⛔ 앱 하단 탭은 탭마다 WebView 가 따로 상주하고, 탭을 누르면 «그 WebView 를 보이게» 만 했다.
 *    그래서 홈 탭에서 동호회 → 행사 → 행사진행·참가신청 현황까지 들어간 뒤 «홈» 을 누르면
 *    (이미 홈 탭이라) 아무 일도 없이 행사진행 화면이 그대로 남았다. 동호회 목록·마이페이지 탭도
 *    그 탭에서 들어간 화면이 그대로 떠 있었다. 웹 하단탭(BottomNavBar)은 누를 때마다 router.push(경로) 다.
 * → 앱이 탭을 누를 때 이 창구를 부른다(React_APP BottomTabNavigator tabPress). 라우터 이동이라
 *   메뉴·행사진행 오버레이(쿼리)도 함께 닫히고, 하드웨어 뒤로가기로 보던 화면에 돌아갈 수 있다(웹과 같다).
 */
if (isInRnWebView()) {
  ;(window as any).__golfTabRoot = (path: unknown) => {
    const p = String(path || '')
    if (!/^\/mobile(\/|$)/.test(p)) return false
    router.push(p).catch((e) => console.warn('[router] 앱 탭 첫 화면 이동 실패', e)) // v12-ok: 탭 이동 실패 — 보던 화면 유지
    return true
  }
}

// 네비게이션 가드 - 인증 및 동호회 회원 확인
router.beforeEach(async (to, _from, next) => {
  // 프리뷰(정적 업로드) 빌드: 네비게이션 가드 전체 우회 — 로그인 없이 임의 페이지 렌더 (디자인 확인용)
  if (import.meta.env.VITE_PREVIEW === '1') return next()
  const authStore = useAuthStore()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  // 앱(RN WebView): 새로 열린 탭 WebView 는 로그인 토큰을 앱이 «문서 로드가 끝난 뒤» localStorage 에 넣는다
  // (WebViewScreen onLoadEnd → injectTokens). 그 전에 판단하면 로그인한 사용자를 가이드/로그인으로 보낸다
  // — 2026-09-27 운영 실측: 로그인 상태에서 마이페이지 탭 → «골총비란?». 첫 이동 1회만 잠깐 기다린다.
  if (requiresAuth && !authStore.isAuthenticated && rnFirstNav && isInRnWebView()) {
    const token = await waitForRnInjectedToken(1500)
    if (token) authStore.setTokens(token, localStorage.getItem('refreshToken') || '')
  }
  rnFirstNav = false
  // 2026-10-03 iOS 심사 2.1(b)(TODO_iOS 심사 §2-4) — 앱은 PC 화면을 쓰지 않는다. PC 화면엔 인앱결제가 없어 구독이
  //   카드 결제(NicePay)로 열린다(외부 결제 유도 위험). PC 주소(공유 링크 등)로 들어오면 모바일 첫 화면으로 보낸다
  if (isInRnWebView() && (to.path === '/pc' || to.path.startsWith('/pc/'))) {
    return next({ path: '/mobile', replace: true })
  }
  // 머지된 meta 기준: 자식 라우트의 명시적 false 가 부모의 true 를 오버라이드 함
  // (예: 인기글에서 진입한 게시글 상세는 비회원도 열람 가능)
  const requiresClub = to.meta.requiresClub === true

  // 1. 인증 확인
  if (requiresAuth && !authStore.isAuthenticated) {
    // 인증이 필요한 페이지인데 로그인하지 않은 경우
    if (to.path.startsWith('/pc/')) {
      next({ name: 'PcLogin', query: { redirect: to.fullPath } })
    } else if (to.meta.guestRedirect) {
      // 2026-06-15 2차요청: 동호회목록·마이페이지 등은 로그인 직행 대신
      // 골총비 서비스소개 초화면(가이드)으로 유도 → 거기서 로그인/회원가입
      // from — 앱에서 토큰이 뒤늦게 들어오면 원래 가려던 화면으로 되돌리기 위해(아래 RN 토큰 감시)
      next({ path: to.meta.guestRedirect as string, query: { from: to.fullPath } })
    } else {
      next({ path: '/mobile/login', query: { returnUrl: to.fullPath } })
    }
    return
  }

  // 2. 로그인 페이지 접근 확인 (이미 로그인한 상태)
  if (to.path === '/pc/login' && authStore.isAuthenticated) {
    next('/pc')
    return
  }
  if (to.path === '/mobile/login' && authStore.isAuthenticated) {
    next('/')
    return
  }

  // 2-1. 모바일 메인은 GuestHome 단일 컴포넌트가 상태별(비로그인/로그인/동호회보유) 렌더를
  //   직접 처리하므로 MobileHome↔GuestHome 리다이렉트는 두지 않는다 (2026-06-18 단일화).
  // PC 비로그인 초화면: 별도 페이지 없이 pc/HomePage 비로그인 분기에서 처리(A안, Q7 갱신 2026-06-05)

  // 2-1. 동호회 권한 판정 전에 멤버십·역할 로드를 보장한다 — 2026-09-03 신설.
  //
  // 아래 requiresOperator / requiresAdmin / requiresClub 은 전부 authStore 의
  // clubMemberships·clubRoles 를 «동기»로 읽는다. 그런데 이 배열을 채우는 유일한
  // 비동기 로드는 App.vue onMounted 에서 await 없이 발사되고, Vue Router 의
  // beforeEach 는 최초 네비게이션에서 App mount 보다 먼저 돈다.
  // → 동호회 경로로 직접 진입하거나 새로고침하면 판정 시점에 목록이 비어 있어
  //   정회원인데도 ClubIntro(가입 랜딩)로 튕겼다.
  // ensureClubMemberships 는 애초에 이 방어를 위해 만들어졌는데(주석에 명시)
  // 라우터에서 호출된 적이 없었다 — 정의·export 만 있고 호출부 0건이었다.
  // 세션당 1회만 실제 로드하므로(membershipsLoaded 가드) 매 네비게이션 비용은 없다.
  // requiresClub 만 to.meta 직접 참조다(아래 4번 블록과 동일 기준을 쓴다)
  const needsClubContext = to.meta.requiresClub === true
    || to.matched.some(record => record.meta.requiresOperator || record.meta.requiresAdmin)
  if (needsClubContext) {
    await authStore.ensureClubMemberships()
  }

  // 2-2. 플랫폼 총무회원(CLUB_MANAGER_YN=Y) 전용 — 3편 p12 ① 프리미엄 신청 내역
  const requiresClubManagerMember = to.matched.some(record => record.meta.requiresClubManagerMember)
  if (requiresClubManagerMember) {
    if (authStore.clubManagerYn !== 'Y') {
      if (to.path.startsWith('/pc/')) {
        next({ path: '/pc/mypage' })
      } else {
        next({ path: '/mobile/mypage' })
      }
      return
    }
  }

  // 3. 쓰기 운영진(총무/부총무) 전용 페이지 확인
  const requiresOperator = to.matched.some(record => record.meta.requiresOperator)
  if (requiresOperator) {
    const { decodeId } = await import('@/utils/sqids')
    const clubCodeParam = to.params.clubCode as string | undefined
    const clubId = clubCodeParam ? decodeId(clubCodeParam) : 0
    if (!clubId || !authStore.isClubOperator(clubId)) {
      console.warn(`Operator access denied for club ${clubId}`)
      if (to.path.startsWith('/pc/')) {
        next({ path: `/pc/club/${clubCodeParam}`, query: { error: 'operator_required' } })
      } else {
        next({ path: `/mobile/club/${clubCodeParam}`, query: { error: 'operator_required' } })
      }
      return
    }
  }

  // 3-1. 조회·승인 운영진(회장/총무/부총무) 전용 페이지 확인
  // clubCode(인코딩 문자열)를 decode해서 정수 clubId로 변환 후 권한 체크
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  if (requiresAdmin) {
    const { decodeId } = await import('@/utils/sqids')
    const clubCodeParam = to.params.clubCode as string | undefined
    const clubId = clubCodeParam ? decodeId(clubCodeParam) : 0
    if (!clubId || !authStore.isClubAdmin(clubId)) {
      console.warn(`Admin access denied for club ${clubId}`)
      // PC/모바일 모두 동호회 홈으로 안내 (로그인 페이지로 보내면 이미 로그인 상태에서 혼란)
      if (to.path.startsWith('/pc/')) {
        next({ path: `/pc/club/${clubCodeParam}`, query: { error: 'admin_required' } })
      } else {
        next({ path: `/mobile/club/${clubCodeParam}`, query: { error: 'admin_required' } })
      }
      return
    }
  }

  // 4. 동호회 회원 확인
  if (requiresClub) {
    const { decodeId } = await import('@/utils/sqids')
    const clubCodeParam = to.params.clubCode as string | undefined
    const clubId = clubCodeParam ? decodeId(clubCodeParam) : 0

    if (!clubId) {
      // clubCode 파라미터가 없거나 decode 실패 시 홈으로 리다이렉트
      console.warn('Club code is missing or invalid')
      if (to.path.startsWith('/pc/')) {
        next({ name: 'PcLogin', query: { redirect: to.fullPath } })
      } else {
        next({ name: 'MobileHome', query: { error: 'club_required' } })
      }
      return
    }

    // 로그인하지 않은 경우 로그인 페이지로
    if (!authStore.isAuthenticated) {
      if (to.path.startsWith('/pc/')) {
        next({ name: 'PcLogin', query: { redirect: to.fullPath } })
      } else {
        next({
          path: '/mobile/login',
          query: { returnUrl: to.fullPath }
        })
      }
      return
    }

    // 동호회 회원이 아닌 경우 동호회 소개 페이지로 리다이렉트 (M-4: 가입하기 랜딩)
    // ClubIntroPage 는 query.clubCode(sqids 인코딩)를 읽으므로 clubSeq(숫자)가 아닌 clubCodeParam 전달
    // ⚠️ 2026-09-05: PC 를 모바일 ClubIntro 로 보내고 있었다(PC-01 위반 — PC 에서 /mobile/* 금지).
    //    PC 는 자기 소개 화면(PcClubIntro, 경로 파라미터)으로 보낸다.
    /* 2026-10-02 (10/1 발주 문서 §7-D2) — «회원 아님»으로 보이면 목록을 한 번 다시 읽고 판정한다.
       회원 목록은 세션당 한 번만 읽어서, 그 사이 가입이 승인된 동호회(앱 상주 웹뷰·오래 연 탭)는 카드는 보이는데
       누르면 소개 화면으로 튕겼다(두 번째부터는 들어가졌다). */
    if (!authStore.isClubMember(clubId) && authStore.isAuthenticated) {
      await authStore.loadClubMemberships()
    }
    if (!authStore.isClubMember(clubId)) {
      console.warn(`User is not a member of club ${clubId}`)
      /* 2026-09-22 — 되돌려보내면서 «왜» 를 함께 보낸다.
         종전에는 console.warn 만 남기고 조용히 튕겨서, 사용자에겐 「눌러도 반응이 없다」로 보였다.
         afterEach 가 이 값을 읽어 토스트로 알린다. */
      if (to.path.startsWith('/pc/')) {
        next({ name: 'PcClubIntro', params: { clubCode: clubCodeParam }, query: { error: 'club_member_required' } })
      } else {
        next({
          name: 'ClubIntro',
          query: { clubCode: clubCodeParam, error: 'club_member_required' }
        })
      }
      return
    }

    /*
     * 임시폐쇄(CLOSE_PENDING) 동호회 — 2026-10-07 10/7본 20번 장.
     * ⛔ 종전엔 서버 GET /api/club/{code} 만 403 이었고 화면은 섹션 오류만 띄운 채 그대로 열렸다.
     * 운영진(회장·총무·부총무)은 환불정산 확정·폐쇄 취소를 해야 하므로 통과한다(서버 판정과 같은 범위).
     * 이전 화면이 있으면 그대로 두고(next(false)), 주소로 바로 들어온 경우엔 내 동호회 목록으로 보낸다.
     */
    if (!authStore.isClubAdmin(clubId)) {
      const { checkClubClosePendingBlocked, notifyClubClosePending } = await import('@/utils/clubClosePending')
      if (await checkClubClosePendingBlocked(clubCodeParam as string)) {
        notifyClubClosePending(clubCodeParam as string)
        if (_from.matched.length > 0) {
          next(false)
        } else {
          next({ path: to.path.startsWith('/pc/') ? '/pc/my-clubs' : '/mobile/mypage/clubs', replace: true })
        }
        return
      }
    }

    /*
     * 무료 기간이 끝나면 일반회원은 «구독으로 제공되는 기능» 만 막는다 — 2026-09-10 사용자 확정.
     *
     * ⛔ 종전에는 동호회 «전체» 를 막고 소개 화면으로 튕겼다(전부 아니면 전무).
     *    그러면 회원이 자기가 쓰던 기록에서 통째로 잘린다.
     *    이제 아래 목록만 막고, 소개·메인·회원목록·가입승인·스폰서·설정·대회·채팅은 열어 둔다.
     *
     * ⚠️ 총무·부총무는 종전대로 전부 통과한다 — 구독을 설정해야 하는 사람이다.
     */
    if (!authStore.isClubOperator(clubId)) {
      const rest = String(to.path).replace(/^\/(mobile|pc)\/club\/[^/]+\/?/, '')
      const head = rest.split('/')[0] || ''
      const PAID_ONLY = [
        'board',                                      // 공지·자유·포토·카풀·스폰서 게시판
        'event', 'events', 'event-recap',             // 행사 목록·상세·참가·조편성·리포트
        'score', 'score-report', 'award-manage',      // 성적·단체성적표·수상
        'vote',                                       // 투표
        'settlement', 'finance-report', 'fee', 'cash' // 정산·회비·지갑·재무보고
      ]
      if (!PAID_ONLY.includes(head)) {
        next()
        return
      }
      try {
        const { clubApi } = await import('@/api/club')
        const clubRes = await clubApi.getClub(clubCodeParam as string)
        if (clubRes.code === 200 && clubRes.data?.memberAccessBlocked) {
          if (to.path.startsWith('/pc/')) {
            next({ name: 'PcClubIntro', params: { clubCode: clubCodeParam }, query: { subExpired: '1' } })
          } else {
            next({
              name: 'ClubIntro',
              query: { clubCode: clubCodeParam, subExpired: '1' }
            })
          }
          return
        }
      } catch (e) {
        // v12-ok: 라우터 가드의 선택적 사전조회(구독 만료) 실패 — 통과시키고 서버가 각 API 에서 다시 막는다
        console.warn('구독 상태 확인 실패', e)
      }
    }
  }

  next()
})

/**
 * 오버레이(메뉴 `?menu=open` · 행사진행 `?progress=open`) 여닫기인지 판별.
 *
 * 이 둘은 «페이지 이동»이 아니라 **보던 화면 위에 레이어를 얹는 것**이다.
 * 경로가 같고 오버레이 쿼리만 달라졌다면 아래 스크롤 리셋을 건너뛴다.
 *
 * ⚠️ 2026-09-18 앱 에뮬레이터 검증에서 발견: 동호회 페이지를 스크롤한 뒤 메뉴를 열었다 닫으면
 *    **보던 위치를 잃고 맨 위로** 돌아갔다. 컴포넌트는 그대로 살아 있었는데(라우트 미변경)
 *    afterEach 가 `.mobile-scroll` 을 0 으로 되돌리고 있었다.
 *    설계(설계_모바일_메뉴_레이어전환_20260724.md §3)가 약속한 「스크롤 보존」이 깨져 있던 것.
 *    웹·앱 공통 증상이다.
 *
 * ⚠️ 판별을 «경로만 같으면» 으로 넓히지 않는다. 목록·검색 페이지들이 필터/페이지 쿼리를 바꿀 때
 *    이 리셋에 의존하고 있다(자체 `window.scrollTo` 는 앱셸 내부 스크롤에 듣지 않는다).
 */
const OVERLAY_QUERY_KEYS = ['menu', 'progress']
const queryWithoutOverlay = (q: RouteLocationNormalized['query']) =>
  Object.keys(q)
    .filter((k) => !OVERLAY_QUERY_KEYS.includes(k))
    .sort()
    .map((k) => `${k}=${String(q[k])}`)
    .join('&')

const isOverlayToggle = (to: RouteLocationNormalized, from: RouteLocationNormalized) =>
  to.path === from.path && queryWithoutOverlay(to.query) === queryWithoutOverlay(from.query)

// 페이지 이동 후 스크롤을 최상단으로 강제 리셋
/* 가드가 되돌려보낸 이유를 한 곳에서 알린다 — 2026-09-22.
 *
 * ⛔ 종전에는 `query.error` 를 **세팅만 하고 읽는 곳이 한 곳도 없었다**
 *    (`operator_required` 는 2026-09-05 에 넣고 지금까지 아무 데서도 안 쓰였다).
 *    그래서 비회원이 동호회 게시판을 누르면 소개 화면으로 조용히 튕겼고,
 *    사용자에겐 「눌러도 반응이 없다」로 보였다.
 *
 * ⚠️ useToast 는 모듈 수준 ref 를 쓰므로 컴포넌트 밖(라우터)에서도 동작한다.
 */
const GUARD_REASON: Record<string, string> = {
  club_member_required: '동호회 회원만 이용할 수 있습니다. 먼저 가입해 주세요.',
  operator_required: '총무·부총무만 이용할 수 있습니다.',
}

router.afterEach((to, from) => {
  const reason = GUARD_REASON[String(to.query.error || '')]
  if (reason) {
    /* 같은 화면을 새로고침해도 다시 뜨지 않도록 안내 후 쿼리를 지운다 */
    import('@/composables').then(({ useToast }) => {
      useToast().error(reason)
      const q = { ...to.query }
      delete q.error
      /* path 에 이미 파라미터가 박혀 있으므로 params 를 함께 주면 안 된다(vue-router 타입) */
      router.replace({ path: to.path, query: q }).catch(() => {})
    })
  }
  if (isOverlayToggle(to, from)) return
  window.scrollTo(0, 0)
  // 모바일은 내부 스크롤 앱셸(MobileLayout '.mobile-scroll')이 실제 스크롤 컨테이너다.
  // 이 컨테이너는 라우트 이동 시에도 유지되어 이전 페이지의 scrollTop 이 남으므로(→ 상세 진입 시 중간부터 보임)
  // window 와 별개로 명시적으로 최상단 리셋. (렌더 타이밍 대비 즉시 + 다음 프레임 2회)
  const resetInner = () => {
    document.querySelectorAll('.mobile-scroll').forEach((el) => {
      ;(el as HTMLElement).scrollTop = 0
    })
  }
  resetInner()
  requestAnimationFrame(resetInner)
})

/* ─────────────────────────────────────────────────────────────────────────
 * 배포 직후 «열어둔 탭» 이 깨지는 것을 자동 복구한다.
 *
 * 2026-09-07 실제 증상 (개발서버 16:40 Vue 재배포 직후):
 *   Failed to load module script: ... MIME type of "text/html"
 *   Failed to fetch dynamically imported module: /assets/LoginPage-Dnb8Xpni.js
 *
 * 왜 나는가 — 빌드마다 청크 파일명 해시가 바뀐다. 배포 전에 페이지를 받은 탭은
 * 옛 해시를 그대로 들고 있다가, 라우트를 옮길 때 그 파일을 요청한다.
 * 그 파일은 이미 없고, nginx 는 SPA 규칙(try_files … /index.html)에 따라
 * **HTML 을 돌려준다**. 브라우저는 JS 모듈을 기대했으므로 MIME 오류를 내고 이동이 실패한다.
 * 사용자에게는 «버튼을 눌렀는데 아무 일도 안 일어남» 으로 보인다.
 *
 * → 청크 로드 실패로 판정되면 «가려던 경로로» 전체 로드를 한 번 한다.
 *   그러면 새 index.html 과 새 청크를 받아 정상 동작한다.
 *
 * ⚠️ 반드시 «한 번만» 해야 한다. 배포가 반쯤 됐거나 청크가 정말 없으면
 *    새로고침 → 또 실패 → 또 새로고침 으로 무한 루프가 되어, 고치려던 것보다 나빠진다.
 *    그래서 직전 시도 시각을 sessionStorage 에 남기고 10초 안에는 다시 하지 않는다.
 *    (localStorage 가 아니라 sessionStorage 다 — 탭을 닫으면 잊는 것이 맞다)
 * ⚠️ 시크릿 모드·저장소 차단 브라우저에서 sessionStorage 접근 자체가 던진다. try/catch 필수.
 */
const CHUNK_LOAD_FAILED =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Expected a JavaScript-or-Wasm module script|Loading chunk \d+ failed/i

const RELOAD_MARK = 'qa_chunk_reload_at'
const RELOAD_COOLDOWN_MS = 10000

router.onError((err, to) => {
  const msg = String((err && (err as Error).message) || err || '')
  if (!CHUNK_LOAD_FAILED.test(msg)) return          // 청크 문제가 아니면 손대지 않는다

  let last = 0
  try { last = Number(sessionStorage.getItem(RELOAD_MARK) || 0) } catch { /* v12-ok: sessionStorage 차단 — 직전 새로고침 기록 없음으로 처리 */ }
  if (last && Date.now() - last < RELOAD_COOLDOWN_MS) {
    // 이미 한 번 시도했는데 또 실패했다 — 새로고침으로는 안 되는 상태다. 루프를 만들지 않는다.
    console.error('[router] 청크 로드가 새로고침 후에도 실패한다 — 배포 상태를 확인해야 한다', msg)
    return
  }
  try { sessionStorage.setItem(RELOAD_MARK, String(Date.now())) } catch { /* v12-ok: sessionStorage 차단 — 기록 없이 새로고침만 시도 */ }

  const target = (to && to.fullPath) || window.location.pathname + window.location.search
  console.warn('[router] 새 배포로 청크가 바뀌었다 — 가려던 경로로 다시 불러온다:', target)
  window.location.assign(target)
})

export default router
